var i18n_private = {
  "en": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Utility<i></i>",
      "pdf_tools": "PDF Tools<i></i>",
      "free_tools": "Free Tools<i></i>",
      "other_tools": "Other Tools<i></i>",
      "free_online": "Free Online<i></i>",
      "desktop": "Desktop<i></i>",
      "store": "Tipard Store",
      "resource": "Resource",
      "points": "Points:",
      "redeem": "Redeem",
      "invite_friends_get_more_points": "Invite Friends & Get More Points",
      "rewards_center": "Rewards Center",
      "windows_software": "Windows Software<i></i>",
      "mac_software": "Mac Software<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Total Media Converter",
      "product_4": "Total Media Converter for Mac",
      "product_5": "Video Converter",
      "product_6": "Video Converter for Mac",
      "product_7": "4K UHD Converter",
      "product_8": "4K Video Converter for Mac",
      "product_9": "Video Enhancer",
      "product_10": "Mac Video Enhancer",
      "product_11": "Screen Capture",
      "product_12": "Screen Capture for Mac",
      "product_13": "3D Converter",
      "product_14": "3D Converter for Mac",
      "product_15": "TS Converter",
      "product_16": "TS Converter for Mac",
      "product_17": "Screen Capture Pro",
      "product_18": "PPT to Video Converter",
      "product_19": "FixMP4 - Video Repair",
      "product_20": "FixMP4 - Video Repair for Mac",
      "product_21": "DVD Ripper",
      "product_22": "DVD Ripper for Mac",
      "product_23": "DVD Creator",
      "product_24": "DVD Creator for Mac",
      "product_25": "DVD Cloner",
      "product_26": "DVD Cloner for Mac",
      "product_27": "Blu-ray Converter",
      "product_28": "Blu-ray Converter for Mac",
      "product_29": "Blu-ray Player",
      "product_30": "Blu-ray Player for Mac",
      "product_31": "Blu-ray Creator",
      "product_32": "Blu-ray Copy",
      "product_33": "Blu-ray Toolkit",
      "product_34": "PDF Converter Platinum",
      "product_35": "PDF to Word Converter",
      "product_36": "PDF Cutter",
      "product_37": "PDF Joiner",
      "product_38": "Windows Password Reset",
      "product_39": "Data Recovery",
      "product_40": "iPhone Transfer",
      "product_41": "iOS Data Recovery",
      "product_42": "Android Data Recovery",
      "product_43": "iPhone Eraser",
      "product_44": "Watermark Remover Free Online",
      "product_45": "Free Video Editor",
      "product_46": "Free DVD to MP3 Converter",
      "product_47": "Free PDF to BMP Converter",
      "download_center": "Download Center",
      "company": "Company",
      "about": "About",
      "privacy_policy": "Privacy Policy",
      "terms_of_use": "Terms of Use",
      "affiliate": "Affiliate",
      "support_center": "Support Center",
      "contact_us": "Contact Us",
      "support": "Support",
      "hot_products": "Hot Products",
      "follow_us": "Follow Us",
      "change_language": "Change Language",

      "product_48":"4K UHD Converter for Mac",
      "blu-ray":"Blu-ray",
      "dvd":"DVD",
      "video_1":"Video",
      "utility_1":"Utility",
      "desktop":"Desktop",
      "online":"Online",
      "view_all_product":"View All Products",
      "product_info_27":"Rip your favorite Blu-ray/DVD movies or videos to popular formats",
      "product_info_29":"Powerful software to play Blu-ray/DVD videos and audio",
      "product_info_31":"Create Blu-ray disc/folder/ISO file with your own video",
      "product_info_32":"Backup/Copy your favorite Blu-ray to disc/folder/iso files",
      "product_info_28":"Rip your favorite Blu-ray/DVD movies or videos to popular formats on Mac",
      "product_info_30":"Powerful software to play Blu-ray/DVD videos and audio on Mac",
      "product_info_21":"Rip DVD to any popular video format quickly of full quality",
      "product_info_23":"Create DVD from videos and burn video to DVD/Blu-ray freely",
      "product_info_25":"Copy DVD to DVD disc/folder/ISO files in a 1:1 ratio",
      "product_info_22":"Rip DVD to any popular video format quickly of full quality on Mac",
      "product_info_24":"Create DVD from videos and burn video to DVD/Blu-ray freely on Mac",
      "product_info_26":"Copy DVD to DVD disc/folder/ISO files in a 1:1 ratio on Mac",
      "product_info_1":"Rip DVD, convert 4K video, edit, and upscale videos to 5K/8K",
      "product_info_19":"Repair broken videos with high accuracy and support many formats",
      "product_info_5":"Convert any video to MP3, MP4, MOV, WAV, and other 350 formats",
      "product_info_9":"Upscale resolution, optimize brightness and remove video noise",
      "product_info_11":"The easiest tool to capture screen,  game, audio, etc. with high quality",
      "product_info_13":"Convert any 2D video to 3D video and convert 3D to 2D video",
      "product_info_7":"Convert 4K video to 4K/1080P and common videos",
      "product_info_15":"Convert TS video to various popular video/audio formats",
      "product_info_2":"Rip DVD, convert 4K video, edit, and upscale videos to 5K/8K on Mac",
      "product_info_20":"Repair broken videos with high accuracy and support many formats on Mac",
      "product_info_6":"Convert any video to MP3, MP4, MOV, WAV, and other 350 formats on Mac",
      "product_info_10":"Upscale resolution, optimize brightness and remove video noise on Mac",
      "product_info_12":"The easiest tool to capture screen,  game, audio, etc. with high quality on Mac",
      "product_info_14":"Convert any 2D video to 3D video and convert 3D to 2D video on Mac",
      "product_info_48":"Convert 4K video to 4K/1080P and common videos on Mac",
      "product_info_16":"Convert TS video to various popular video/audio formats on Mac",
      "product_info_46":"Rip and convert DVDs to MP3 and support other audio formats",
      "product_info_38":"Reset Windows Admin and Standard user account password in seconds",
      "product_info_35":"Accurately Convert any PDF file to Word with OCR",
      "product_info_34":"Convert PDF to Word, Excel, HTML and Image with OCR",
      "product_info_44":"Easily remove watermarks from many image file formats free online",
  },
  "fr": {
      "video": "Vidéo<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Utilitaire<i></i>",
      "pdf_tools": "Outils PDF<i></i>",
      "free_tools": "Outils gratuits<i></i>",
      "other_tools": "Autres outils<i></i>",
      "free_online": "Gratuit en ligne<i></i>",
      "desktop": "Bureau<i></i>",
      "store": "Magasin Tipard",
      "resource": "Ressource",
      "points": "Points:",
      "redeem": "Racheter",
      "invite_friends_get_more_points": "Invitez des amis et obtenez plus de points",
      "rewards_center": "Centre de récompenses",
      "windows_software": "Logiciel Windows<i></i>",
      "mac_software": "Logiciel Mac<i></i>",
      "product_1": "Convertisseur Vidéo Ultimate",
      "product_2": "Convertisseur vidéo ultime pour Mac",
      "product_3": "Convertisseur de média total",
      "product_4": "Total Media Converter pour Mac",
      "product_5": "Convertisseur vidéo",
      "product_6": "Convertisseur vidéo pour Mac",
      "product_7": "Convertisseur 4K UHD",
      "product_8": "Convertisseur vidéo 4K pour Mac",
      "product_9": "Amplificateur vidéo",
      "product_10": "Optimiseur de vidéo pour Mac",
      "product_11": "Capture d'écran",
      "product_12": "Capture d'écran pour Mac",
      "product_13": "Convertisseur 3D",
      "product_14": "Convertisseur 3D pour Mac",
      "product_15": "Convertisseur TS",
      "product_16": "Convertisseur TS pour Mac",
      "product_17": "Capture d'écran Pro",
      "product_18": "Convertisseur PPT en vidéo",
      "product_19": "FixMP4 - Réparation vidéo",
      "product_20": "FixMP4 – Réparation vidéo pour Mac",
      "product_21": "Extracteur de DVD",
      "product_22": "Extracteur de DVD pour Mac",
      "product_23": "Créateur de DVD",
      "product_24": "Créateur de DVD pour Mac",
      "product_25": "Cloneur de DVD",
      "product_26": "Cloneur de DVD pour Mac",
      "product_27": "Convertisseur Blu-ray",
      "product_28": "Convertisseur Blu-ray pour Mac",
      "product_29": "Lecteur Blu-ray",
      "product_30": "Lecteur Blu-ray pour Mac",
      "product_31": "Créateur de Blu-ray",
      "product_32": "Copie Blu-ray",
      "product_33": "Boîte à outils Blu-ray",
      "product_34": "Convertisseur PDF Platinum",
      "product_35": "Convertisseur PDF en Word",
      "product_36": "Découpeur PDF",
      "product_37": "PDF Joiner",
      "product_38": "Réinitialisation du mot de passe Windows",
      "product_39": "Récupération de données",
      "product_40": "Transfert iPhone",
      "product_41": "Récupération de données iOS",
      "product_42": "Récupération de données Android",
      "product_43": "Gomme pour iPhone",
      "product_44": "Suppression de filigrane gratuite en ligne",
      "product_45": "Éditeur vidéo gratuit",
      "product_46": "Convertisseur DVD en MP3 gratuit",
      "product_47": "Convertisseur PDF en BMP gratuit",
      "download_center": "Centre de téléchargement",
      "company": "Entreprise",
      "about": "À propos",
      "privacy_policy": "politique de confidentialité",
      "terms_of_use": "Conditions d'utilisation",
      "affiliate": "Filiale",
      "support_center": "Centre d'assistance",
      "contact_us": "Contactez-nous",
      "support": "Soutien",
      "hot_products": "Produits phares",
      "follow_us": "Suivez-nous",
      "change_language": "Changer la langue",

    "product_48": "Convertisseur Vidéo 4K pour Mac",
    "blu-ray": "Blu-ray",
    "dvd": "DVD",
    "video_1": "Vidéo",
    "utility_1": "Utilité",
    "desktop": "Bureau",
    "online": "En ligne",
    "view_all_product": "Découvrer Tous les Produits",
    "product_info_27": "Ripper vos films ou vidéos Blu-ray/DVD préférés dans les formats les plus courants",
    "product_info_29": "Logiciel puissant pour lire les vidéos et les fichiers audio Blu-ray/DVD",
    "product_info_31": "Créer un disque Blu-ray/un dossier/un fichier ISO avec votre propre vidéo",
    "product_info_32": "Sauvegarder/copier vos Blu-ray préférés sur un disque/un dossier/des fichiers ISO",
    "product_info_28": "Ripper vos films ou vidéos Blu-ray/DVD préférés dans les formats les plus courants sur Mac",
    "product_info_30": "Logiciel puissant pour lire les vidéos et les fichiers audio Blu-ray/DVD sur Mac",
    "product_info_21": "Ripper rapidement des DVD vers tous les formats vidéo courants avec une qualité optimale",
    "product_info_23": "Créer des DVD à partir de vidéos et graver des vidéos sur DVD/Blu-ray librement",
    "product_info_25": "Copier un DVD vers un disque/dossier/fichiers ISO DVD dans un rapport 1:1",
    "product_info_22": "Ripper rapidement des DVD vers tous les formats vidéo courants avec une qualité optimale sur Mac",
    "product_info_24": "Créer des DVD à partir de vidéos et graver des vidéos sur DVD/Blu-ray librement sur Mac",
    "product_info_26": "Copier un DVD vers un disque/dossier/fichiers ISO DVD dans un rapport 1:1 sur Mac",
    "product_info_1": "Ripper des DVD, convertir des vidéos 4K, éditer et convertir des vidéos en 5K/8K",
    "product_info_19": "Réparer les vidéos cassées avec une grande précision et prendre en charge de nombreux formats",
    "product_info_5": "Convertir n'importe quelle vidéo en MP3, MP4, MOV, WAV et autres 350 formats",
    "product_info_9": "Augmenter la résolution, optimiser la luminosité et supprimer le bruit vidéo",
    "product_info_11": "L'outil le plus simple pour capturer l'écran, le jeu, l'audio, etc. en haute qualité",
    "product_info_13": "Convertir n'importe quelle vidéo 2D en vidéo 3D et convertir des vidéos 3D en vidéos 2D",
    "product_info_7": "Convertir des vidéos 4K en 4K/1080P et des vidéos courantes",
    "product_info_15": "Convertir des vidéos TS en divers formats vidéo/audio populaires",
    "product_info_2": "Ripper des DVD, convertir des vidéos 4K, éditer et convertir des vidéos en 5K/8K sur Mac",
    "product_info_20": "Réparer les vidéos cassées avec une grande précision et prendre en charge de nombreux formats sur Mac",
    "product_info_6": "Convertir n'importe quelle vidéo en MP3, MP4, MOV, WAV et autres 350 formats sur Mac",
    "product_info_10": "Augmenter la résolution, optimiser la luminosité et supprimer le bruit vidéo sur Mac",
    "product_info_12": "L'outil le plus simple pour capturer l'écran, le jeu, l'audio, etc. en haute qualité sur Mac",
    "product_info_14": "Convertir n'importe quelle vidéo 2D en vidéo 3D et convertir des vidéos 3D en vidéos 2D sur Mac",
    "product_info_48": "Convertir des vidéos 4K en 4K/1080P et des vidéos courantes sur Mac",
    "product_info_16": "Convertir des vidéos TS en divers formats vidéo/audio populaires sur Mac",
    "product_info_46": "Ripper et convertir des DVD en MP3 et prendre en charge d'autres formats audio",
    "product_info_38": "Réinitialiser le mot de passe des comptes d'utilisateurs Windows Admin et Standard en quelques secondes",
    "product_info_35": "Convertir avec précision n'importe quel fichier PDF en Word avec l'OCR",
    "product_info_34": "Convertir les PDF en Word, Excel, HTML et images avec OCR",
    "product_info_44": "Supprimer facilement les filigranes de nombreux formats de fichiers image gratuitement en ligne",
  },
  "ja": {
      "video": "ビデオ<i></i>",
      "blu_ray_dvd": "ブルーレイ/DVD<i></i>",
      "utility": "ユーティリティ<i></i>",
      "pdf_tools": "PDFツール<i></i>",
      "free_tools": "無料ツール<i></i>",
      "other_tools": "その他のツール<i></i>",
      "free_online": "無料オンライン<i></i>",
      "desktop": "デスクトップ<i></i>",
      "store": "ティパードストア",
      "resource": "リソース",
      "points": "ポイント:",
      "redeem": "償還",
      "invite_friends_get_more_points": "友達を招待してポイントをゲット",
      "rewards_center": "リワードセンター",
      "windows_software": "Windows ソフトウェア<i></i>",
      "mac_software": "Mac ソフトウェア<i></i>",
      "product_1": "動画変換 究極",
      "product_2": "Mac ビデオコンバーター 究極",
      "product_3": "トータルメディアコンバータ",
      "product_4": "Mac用トータルメディアコンバータ",
      "product_5": "ビデオコンバーター",
      "product_6": "Mac用ビデオコンバーター",
      "product_7": "4K UHDコンバータ",
      "product_8": "Mac用4Kビデオコンバーター",
      "product_9": "ビデオエンハンサー",
      "product_10": "Mac ビデオ エンハンサー",
      "product_11": "スクリーンキャプチャ",
      "product_12": "Mac用スクリーンキャプチャ",
      "product_13": "3Dコンバーター",
      "product_14": "Mac用3Dコンバーター",
      "product_15": "TSコンバータ",
      "product_16": "Mac用TSコンバータ",
      "product_17": "スクリーンキャプチャプロ",
      "product_18": "PPTからビデオへのコンバーター",
      "product_19": "FixMP4 - ビデオ修復",
      "product_20": "FixMP4 - Mac用ビデオ修復",
      "product_21": "DVDリッパー",
      "product_22": "Mac用DVDリッパー",
      "product_23": "DVD クリエーター",
      "product_24": "Mac用DVDクリエーター",
      "product_25": "DVD クローナー",
      "product_26": "Mac用DVDクローナー",
      "product_27": "ブルーレイコンバーター",
      "product_28": "Mac用ブルーレイコンバータ",
      "product_29": "ブルーレイプレーヤー",
      "product_30": "Mac用ブルーレイプレーヤー",
      "product_31": "ブルーレイ クリエーター",
      "product_32": "ブルーレイコピー",
      "product_33": "ブルーレイツールキット",
      "product_34": "PDFコンバータープラチナ",
      "product_35": "PDFからWordへのコンバーター",
      "product_36": "PDFカッター",
      "product_37": "PDF ジョイナー",
      "product_38": "Windows パスワードのリセット",
      "product_39": "データ復旧",
      "product_40": "iPhone転送",
      "product_41": "iOSデータ復旧",
      "product_42": "Android データ復旧",
      "product_43": "iPhone 消しゴム",
      "product_44": "透かし除去無料オンライン",
      "product_45": "無料ビデオエディタ",
      "product_46": "無料のDVDからMP3へのコンバーター",
      "product_47": "無料の PDF から BMP へのコンバーター",
      "download_center": "ダウンロードセンター",
      "company": "会社",
      "about": "について",
      "privacy_policy": "プライバシーポリシー",
      "terms_of_use": "利用規約",
      "affiliate": "アフィリエイト",
      "support_center": "サポートセンター",
      "contact_us": "お問い合わせ",
      "support": "サポート",
      "hot_products": "人気商品",
      "follow_us": "私たちに従ってください",
      "change_language": "言語を変更",
      "product_48": "4K 変換 for Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "動画",
      "utility_1": "ユーティリティ",
      "desktop": "デスクトップ",
      "online": "オンライン",
      "view_all_product": "全製品を表示",
      "product_info_27": "お気に入りのBlu-ray/DVD ムービーや動画を一般的な形式にリッピング",
      "product_info_29": "Blu-ray/DVD動画と音声を再生する強力なソフトウェア",
      "product_info_31": "自分の動画をBlu-rayディスク/フォルダ/ISO ファイルに作成",
      "product_info_32": "お気に入りのBlu-rayを他のディスク/フォルダ/ISO ファイルにバックアップ、コピー",
      "product_info_28": "Macでお気に入りのBlu-ray/DVD ムービーや動画を一般的な形式にリッピング",
      "product_info_30": "MacでBlu-ray/DVD動画と音声を再生する強力なソフトウェア",
      "product_info_21": "DVDをあらゆる一般的な動画形式に高品質で素早くリッピング",
      "product_info_23": "動画からDVDに作成し、動画をDVD/Blu-rayに自由に書き込む",
      "product_info_25": "DVDをDVDディスク/フォルダ/ISO ファイルに 1:1の比率でコピー",
      "product_info_22": "MacでDVDをあらゆる一般的な動画形式に高品質で素早くリッピング",
      "product_info_24": "Macで動画からDVDに作成し、動画をDVD/Blu-rayに自由に書き込む",
      "product_info_26": "MacでDVDを1:1の比率でDVDディスク/フォルダ/ISOファイルにコピー",
      "product_info_1": "DVDリッピング、4K 動画変換、動画編集、5K/8K にアップスケールすることができ",
      "product_info_19": "壊れた動画を高精度で修復し、多くの形式をサポートする",
      "product_info_5": "動画をMP3、MP4、MOV、WAV、その他350などの形式に変換",
      "product_info_9": "解像度を上げ、明るさを最適化し、動画ノイズを除去する",
      "product_info_11": "画面、ゲーム、音声などを高品質でキャプチャする最も簡単なソフト",
      "product_info_13": "あらゆる2D動画を3D動画に変換し、3Dを 2D動画に変換",
      "product_info_7": "4K 動画を 4K/1080P および一般的な動画に変換する",
      "product_info_15": "TS動画をさまざまな一般的な動画/音声形式に変換",
      "product_info_2": "MacでDVDリッピング、4K 動画変換、動画編集、5K/8K にアップスケールすることができ",
      "product_info_20": "Macで壊れた動画を高精度で修復し、多くの形式をサポートする",
      "product_info_6": "Macで動画をMP3、MP4、MOV、WAV、その他350などの形式に変換",
      "product_info_10": "Macで解像度を上げ、明るさを最適化し、動画ノイズを除去する",
      "product_info_12": "Macで画面、ゲーム、音声などを高品質でキャプチャする最も簡単なソフト",
      "product_info_14": "Macであらゆる2D動画を3D動画に変換し、3Dを 2D動画に変換",
      "product_info_48": "Macで 4K 動画を 4K/1080P および一般的な動画に変換",
      "product_info_16": "MacでTS動画をさまざまな一般的な動画/音声形式に変換",
      "product_info_46": "DVDリッピングしてMP3に変換し、その他の音声形式をサポート",
      "product_info_38": "Windows 管理者および標準ユーザーアカウントのパスワードを数秒でリセット",
      "product_info_35": "OCRを使ってあらゆるPDFファイルをWordに変換",
      "product_info_34": "OCRを使ってPDFをWord、Excel、HTML、画像に変換",
      "product_info_44": "オンラインで無料で、さまざまな画像ファイル形式から透かしを簡単に削除できます"
  },
  "es": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Utilidad<i></i>",
      "pdf_tools": "Herramientas PDF<i></i>",
      "free_tools": "Herramientas gratuitas<i></i>",
      "other_tools": "Otras herramientas<i></i>",
      "free_online": "Gratis en línea<i></i>",
      "desktop": "De oficina<i></i>",
      "store": "Tienda Tipard",
      "resource": "Recurso",
      "points": "Agujas:",
      "redeem": "Canjear",
      "invite_friends_get_more_points": "Invita a tus amigos y obtén más puntos",
      "rewards_center": "Centro de recompensas",
      "windows_software": "Software de Windows<i></i>",
      "mac_software": "Software para Mac<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Convertidor de vídeo definitivo para Mac",
      "product_3": "Convertidor de medios total",
      "product_4": "Convertidor multimedia total para Mac",
      "product_5": "Convertidor de vídeo",
      "product_6": "Convertidor de vídeo para Mac",
      "product_7": "Convertidor 4K UHD",
      "product_8": "Convertidor de vídeo 4K para Mac",
      "product_9": "Mejorador de vídeo",
      "product_10": "Mejorador de vídeo para Mac",
      "product_11": "Captura de pantalla",
      "product_12": "Captura de pantalla para Mac",
      "product_13": "Convertidor 3D",
      "product_14": "Convertidor 3D para Mac",
      "product_15": "Convertidor TS",
      "product_16": "Convertidor TS para Mac",
      "product_17": "Captura de pantalla profesional",
      "product_18": "Convertidor de PPT a vídeo",
      "product_19": "FixMP4 - Reparación de videos",
      "product_20": "FixMP4 - Reparación de videos para Mac",
      "product_21": "Extractor de DVD",
      "product_22": "Extractor de DVD para Mac",
      "product_23": "Creador de DVD",
      "product_24": "Creador de DVD para Mac",
      "product_25": "Clonador de DVD",
      "product_26": "Clonador de DVD para Mac",
      "product_27": "Convertidor de Blu-ray",
      "product_28": "Convertidor de Blu-ray para Mac",
      "product_29": "Reproductor de Blu-ray",
      "product_30": "Reproductor de Blu-ray para Mac",
      "product_31": "Creador de Blu-ray",
      "product_32": "Copia de Blu-ray",
      "product_33": "Kit de herramientas para Blu-ray",
      "product_34": "Convertidor de PDF Platino",
      "product_35": "Convertidor de PDF a Word",
      "product_36": "Cortador de PDF",
      "product_37": "Unificador de PDF",
      "product_38": "Restablecimiento de contraseña de Windows",
      "product_39": "Recuperación de datos",
      "product_40": "Transferencia de iPhone",
      "product_41": "Recuperación de datos de iOS",
      "product_42": "Recuperación de datos de Android",
      "product_43": "Borrador de iPhone",
      "product_44": "Eliminador de marcas de agua en línea gratis",
      "product_45": "Editor de vídeo gratuito",
      "product_46": "Convertidor gratuito de DVD a MP3",
      "product_47": "Convertidor gratuito de PDF a BMP",
      "download_center": "Centro de descargas",
      "company": "Compañía",
      "about": "Acerca de",
      "privacy_policy": "política de privacidad",
      "terms_of_use": "Condiciones de uso",
      "affiliate": "Filial",
      "support_center": "Centro de soporte",
      "contact_us": "Contáctenos",
      "support": "Apoyo",
      "hot_products": "Productos destacados",
      "follow_us": "Síganos",
      "change_language": "Cambiar idioma",
      "product_48": "Convertidor 4K UHD para Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Video",
      "utility_1": "Utilidad",
      "desktop": "De oficina",
      "online": "En línea",
      "view_all_product": "Ver todos los productos",
      "product_info_27": "Copia tus películas o vídeos Blu-ray/DVD favoritos a formatos populares",
      "product_info_29": "Potente software para reproducir vídeos y audio Blu-ray/DVD",
      "product_info_31": "Crea un disco/carpeta/archivo ISO Blu-ray con tu propio vídeo",
      "product_info_32": "Realice una copia de seguridad de sus Blu-ray favoritos en un disco/carpeta/archivos ISO",
      "product_info_28": "Copia tus películas o vídeos Blu-ray/DVD favoritos a formatos populares en Mac",
      "product_info_30": "Potente software para reproducir vídeos y audio Blu-ray/DVD en Mac",
      "product_info_21": "Copia DVD a cualquier formato de vídeo popular rápidamente y con total calidad",
      "product_info_23": "Cree DVD a partir de vídeos y grabe vídeos en DVD/Blu-ray libremente",
      "product_info_25": "Copiar DVD a discos DVD/carpetas/archivos ISO en una proporción de 1:1",
      "product_info_22": "Copia DVD a cualquier formato de vídeo popular rápidamente y con total calidad en Mac",
      "product_info_24": "Cree DVD a partir de vídeos y grabe vídeos en DVD/Blu-ray libremente en Mac",
      "product_info_26": "Copiar DVD a disco DVD/carpeta/archivos ISO en una proporción 1:1 en Mac",
      "product_info_1": "Copiar DVD, convertir videos 4K, editar y mejorar la resolución de videos a 5K/8K",
      "product_info_19": "Repara videos dañados con alta precisión y admite muchos formatos.",
      "product_info_5": "Convierte cualquier vídeo a MP3, MP4, MOV, WAV y otros 350 formatos",
      "product_info_9": "Aumente la resolución, optimice el brillo y elimine el ruido del video",
      "product_info_11": "La herramienta más sencilla para capturar pantalla, juegos, audio, etc. con alta calidad.",
      "product_info_13": "Convierte cualquier vídeo 2D a vídeo 3D y convierte vídeo 3D a 2D",
      "product_info_7": "Convierte videos 4K a 4K/1080P y videos comunes",
      "product_info_15": "Convierte vídeos TS a varios formatos de vídeo y audio populares",
      "product_info_2": "Copia DVD, convierte videos 4K, edita y mejora la resolución de videos a 5K/8K en Mac",
      "product_info_20": "Repara videos dañados con alta precisión y admite muchos formatos en Mac",
      "product_info_6": "Convierte cualquier vídeo a MP3, MP4, MOV, WAV y otros 350 formatos en Mac",
      "product_info_10": "Aumente la resolución, optimice el brillo y elimine el ruido del video en Mac",
      "product_info_12": "La herramienta más sencilla para capturar pantalla, juegos, audio, etc. con alta calidad en Mac",
      "product_info_14": "Convierte cualquier vídeo 2D a vídeo 3D y convierte vídeo 3D a 2D en Mac",
      "product_info_48": "Convierte videos 4K a 4K/1080P y videos comunes en Mac",
      "product_info_16": "Convierte videos TS a varios formatos de video/audio populares en Mac",
      "product_info_46": "Extrae y convierte DVD a MP3 y admite otros formatos de audio",
      "product_info_38": "Restablecer la contraseña de la cuenta de usuario estándar y administrador de Windows en segundos",
      "product_info_35": "Convierte con precisión cualquier archivo PDF a Word con OCR",
      "product_info_34": "Convierte PDF a Word, Excel, HTML e imágenes con OCR",
      "product_info_44": "Elimine fácilmente marcas de agua de muchos formatos de archivos de imagen de forma gratuita en línea",
  },
  "pt": {
      "video": "Vídeo<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Utilitário<i></i>",
      "pdf_tools": "Ferramentas PDF<i></i>",
      "free_tools": "Ferramentas gratuitas<i></i>",
      "other_tools": "Outras ferramentas<i></i>",
      "free_online": "Grátis Online<i></i>",
      "desktop": "Área de trabalho<i></i>",
      "store": "Loja Tipard",
      "resource": "Recurso",
      "points": "Pontos:",
      "redeem": "Resgatar",
      "invite_friends_get_more_points": "Convide amigos e ganhe mais pontos",
      "rewards_center": "Centro de recompensas",
      "windows_software": "Software Windows<i></i>",
      "mac_software": "Software para Mac<i></i>",
      "product_1": "Conversor de vídeo Ultimate",
      "product_2": "Conversor de vídeo para Mac Ultimate",
      "product_3": "Conversor de mídia total",
      "product_4": "Total Media Converter para Mac",
      "product_5": "Conversor de vídeo",
      "product_6": "Conversor de vídeo para Mac",
      "product_7": "Conversor 4K UHD",
      "product_8": "Conversor de vídeo 4K para Mac",
      "product_9": "Aprimorador de vídeo",
      "product_10": "Melhorador de vídeo para Mac",
      "product_11": "Captura de tela",
      "product_12": "Captura de tela para Mac",
      "product_13": "Conversor 3D",
      "product_14": "Conversor 3D para Mac",
      "product_15": "Conversor TS",
      "product_16": "Conversor TS para Mac",
      "product_17": "Captura de tela profissional",
      "product_18": "Conversor PPT para vídeo",
      "product_19": "FixMP4 - Reparo de Vídeo",
      "product_20": "FixMP4 - Reparo de vídeo para Mac",
      "product_21": "Ripador de DVD",
      "product_22": "DVD Ripper para Mac",
      "product_23": "Criador de DVD",
      "product_24": "Criador de DVD para Mac",
      "product_25": "Clonador de DVD",
      "product_26": "DVD Cloner para Mac",
      "product_27": "Conversor Blu-ray",
      "product_28": "Conversor Blu-ray para Mac",
      "product_29": "Leitor de Blu-ray",
      "product_30": "Leitor de Blu-ray para Mac",
      "product_31": "Criador de Blu-ray",
      "product_32": "Cópia Blu-ray",
      "product_33": "Kit de ferramentas Blu-ray",
      "product_34": "Conversor PDF Platinum",
      "product_35": "Conversor de PDF para Word",
      "product_36": "Cortador de PDF",
      "product_37": "Juntador de PDF",
      "product_38": "Redefinição de senha do Windows",
      "product_39": "Recuperação de dados",
      "product_40": "Transferência do iPhone",
      "product_41": "Recuperação de dados iOS",
      "product_42": "Recuperação de dados do Android",
      "product_43": "Borracha para iPhone",
      "product_44": "Removedor de marca d'água grátis online",
      "product_45": "Editor de vídeo grátis",
      "product_46": "Conversor de DVD para MP3 grátis",
      "product_47": "Conversor gratuito de PDF para BMP",
      "download_center": "Centro de download",
      "company": "Empresa",
      "about": "Sobre",
      "privacy_policy": "política de Privacidade",
      "terms_of_use": "Termos de Uso",
      "affiliate": "Afiliado",
      "support_center": "Centro de Suporte",
      "contact_us": "Contate-nos",
      "support": "Apoiar",
      "hot_products": "Produtos quentes",
      "follow_us": "Siga-nos",
      "change_language": "Alterar idioma",
      "product_48": "Conversor 4K UHD para Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Vídeo",
      "utility_1": "Utilitário",
      "desktop": "Área de trabalho",
      "online": "On-line",
      "view_all_product": "Ver todos os produtos",
      "product_info_27": "Extraia seus filmes ou vídeos favoritos em Blu-ray/DVD para formatos populares",
      "product_info_29": "Software poderoso para reproduzir vídeos e áudio Blu-ray/DVD",
      "product_info_31": "Crie um disco Blu-ray/pasta/arquivo ISO com seu próprio vídeo",
      "product_info_32": "Faça backup/copie seu Blu-ray favorito para disco/pasta/arquivos iso",
      "product_info_28": "Copie seus filmes ou vídeos favoritos em Blu-ray/DVD para formatos populares no Mac",
      "product_info_30": "Software poderoso para reproduzir vídeos e áudio Blu-ray/DVD no Mac",
      "product_info_21": "Copie DVD para qualquer formato de vídeo popular rapidamente e com qualidade total",
      "product_info_23": "Crie DVD a partir de vídeos e grave vídeos em DVD/Blu-ray livremente",
      "product_info_25": "Copie DVD para disco DVD/pasta/arquivos ISO em uma proporção de 1:1",
      "product_info_22": "Copie DVD para qualquer formato de vídeo popular rapidamente e com qualidade total no Mac",
      "product_info_24": "Crie DVD a partir de vídeos e grave vídeos em DVD/Blu-ray livremente no Mac",
      "product_info_26": "Copie DVD para disco/pasta/arquivos ISO de DVD em uma proporção de 1:1 no Mac",
      "product_info_1": "Copie DVD, converta vídeo 4K, edite e aprimore vídeos para 5K/8K",
      "product_info_19": "Repara vídeos quebrados com alta precisão e suporta muitos formatos",
      "product_info_5": "Converta qualquer vídeo para MP3, MP4, MOV, WAV e outros 350 formatos",
      "product_info_9": "Melhore a resolução, otimize o brilho e remova o ruído do vídeo",
      "product_info_11": "A ferramenta mais fácil para capturar tela, jogo, áudio, etc. com alta qualidade",
      "product_info_13": "Converta qualquer vídeo 2D em vídeo 3D e converta vídeo 3D em 2D",
      "product_info_7": "Converta vídeo 4K para 4K/1080P e vídeos comuns",
      "product_info_15": "Converta vídeo TS para vários formatos populares de vídeo/áudio",
      "product_info_2": "Copie DVD, converta vídeo 4K, edite e aprimore vídeos para 5K/8K no Mac",
      "product_info_20": "Repare vídeos quebrados com alta precisão e suporte a muitos formatos no Mac",
      "product_info_6": "Converta qualquer vídeo para MP3, MP4, MOV, WAV e outros 350 formatos no Mac",
      "product_info_10": "Melhore a resolução, otimize o brilho e remova o ruído do vídeo no Mac",
      "product_info_12": "A ferramenta mais fácil para capturar tela, jogo, áudio, etc. com alta qualidade no Mac",
      "product_info_14": "Converta qualquer vídeo 2D em vídeo 3D e converta vídeo 3D em 2D no Mac",
      "product_info_48": "Converta vídeo 4K para 4K/1080P e vídeos comuns no Mac",
      "product_info_16": "Converta vídeo TS para vários formatos populares de vídeo/áudio no Mac",
      "product_info_46": "Extraia e converta DVDs para MP3 e suporte outros formatos de áudio",
      "product_info_38": "Redefinir a senha da conta de administrador e usuário padrão do Windows em segundos",
      "product_info_35": "Converta com precisão qualquer arquivo PDF para Word com OCR",
      "product_info_34": "Converta PDF para Word, Excel, HTML e Imagem com OCR",
      "product_info_44": "Remova facilmente marcas d'água de muitos formatos de arquivo de imagem gratuitamente online",
  },
  "it": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Utilità<i></i>",
      "pdf_tools": "Strumenti PDF<i></i>",
      "free_tools": "Strumenti gratuiti<i></i>",
      "other_tools": "Altri strumenti<i></i>",
      "free_online": "Gratis online<i></i>",
      "desktop": "Scrivania<i></i>",
      "store": "Negozio Tipard",
      "resource": "Risorsa",
      "points": "Punti:",
      "redeem": "Riscattare",
      "invite_friends_get_more_points": "Invita gli amici e ottieni più punti",
      "rewards_center": "Centro premi",
      "windows_software": "Software per Windows<i></i>",
      "mac_software": "Software per Mac<i></i>",
      "product_1": "Convertitore video definitivo",
      "product_2": "Convertitore video per Mac Ultimate",
      "product_3": "Convertitore multimediale totale",
      "product_4": "Total Media Converter per Mac",
      "product_5": "Convertitore video",
      "product_6": "Convertitore video per Mac",
      "product_7": "Convertitore 4K UHD",
      "product_8": "Convertitore video 4K per Mac",
      "product_9": "Miglioratore video",
      "product_10": "Ottimizzatore video per Mac",
      "product_11": "Cattura dello schermo",
      "product_12": "Cattura schermo per Mac",
      "product_13": "Convertitore 3D",
      "product_14": "Convertitore 3D per Mac",
      "product_15": "Convertitore TS",
      "product_16": "Convertitore TS per Mac",
      "product_17": "Cattura schermo Pro",
      "product_18": "Convertitore da PPT a Video",
      "product_19": "FixMP4 - Riparazione video",
      "product_20": "FixMP4 - Riparazione video per Mac",
      "product_21": "Ripper per DVD",
      "product_22": "Ripper DVD per Mac",
      "product_23": "Creatore di DVD",
      "product_24": "Creatore DVD per Mac",
      "product_25": "Clonatore DVD",
      "product_26": "Clonatore DVD per Mac",
      "product_27": "Convertitore Blu-ray",
      "product_28": "Convertitore Blu-ray per Mac",
      "product_29": "Lettore Blu-ray",
      "product_30": "Lettore Blu-ray per Mac",
      "product_31": "Creatore di Blu-ray",
      "product_32": "Copia Blu-ray",
      "product_33": "Kit di strumenti Blu-ray",
      "product_34": "Convertitore PDF Platino",
      "product_35": "Convertitore da PDF a Word",
      "product_36": "Taglierina PDF",
      "product_37": "Unire PDF",
      "product_38": "Reimpostazione password di Windows",
      "product_39": "Recupero dati",
      "product_40": "Trasferimento iPhone",
      "product_41": "Recupero dati iOS",
      "product_42": "Recupero dati Android",
      "product_43": "Gomma per iPhone",
      "product_44": "Rimozione filigrana gratuita online",
      "product_45": "Editor video gratuito",
      "product_46": "Convertitore gratuito da DVD a MP3",
      "product_47": "Convertitore gratuito da PDF a BMP",
      "download_center": "Centro download",
      "company": "Azienda",
      "about": "Di",
      "privacy_policy": "politica sulla riservatezza",
      "terms_of_use": "Termini di utilizzo",
      "affiliate": "Affiliato",
      "support_center": "Centro di supporto",
      "contact_us": "Contattaci",
      "support": "Supporto",
      "hot_products": "Prodotti caldi",
      "follow_us": "Seguici",
      "change_language": "Cambia lingua",
      "product_48": "Convertitore 4K UHD per Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Video",
      "utility_1": "Utilità",
      "desktop": "Scrivania",
      "online": "In linea",
      "view_all_product": "Visualizza tutti i prodotti",
      "product_info_27": "Copia i tuoi film o video Blu-ray/DVD preferiti nei formati più diffusi",
      "product_info_29": "Potente software per riprodurre video e audio Blu-ray/DVD",
      "product_info_31": "Crea un disco Blu-ray/cartella/file ISO con il tuo video",
      "product_info_32": "Esegui il backup/copia il tuo Blu-ray preferito su disco/cartella/file ISO",
      "product_info_28": "Copia i tuoi film o video Blu-ray/DVD preferiti nei formati più diffusi su Mac",
      "product_info_30": "Potente software per riprodurre video e audio Blu-ray/DVD su Mac",
      "product_info_21": "Copia DVD in qualsiasi formato video popolare in modo rapido e con la massima qualità",
      "product_info_23": "Crea DVD dai video e masterizza i video su DVD/Blu-ray liberamente",
      "product_info_25": "Copia DVD su disco DVD/cartella/file ISO in un rapporto 1:1",
      "product_info_22": "Copia DVD in qualsiasi formato video popolare in modo rapido e ad alta qualità su Mac",
      "product_info_24": "Crea DVD da video e masterizza video su DVD/Blu-ray liberamente su Mac",
      "product_info_26": "Copia DVD su disco DVD/cartella/file ISO in un rapporto 1:1 su Mac",
      "product_info_1": "Copia DVD, converti video 4K, modifica e converti video in 5K/8K",
      "product_info_19": "Ripara i video danneggiati con elevata precisione e supporta molti formati",
      "product_info_5": "Converti qualsiasi video in MP3, MP4, MOV, WAV e altri 350 formati",
      "product_info_9": "Risoluzione migliorata, ottimizzazione della luminosità e rimozione del rumore video",
      "product_info_11": "Lo strumento più semplice per catturare schermate, giochi, audio, ecc. con alta qualità",
      "product_info_13": "Converti qualsiasi video 2D in video 3D e converti video 3D in 2D",
      "product_info_7": "Converti video 4K in 4K/1080P e video comuni",
      "product_info_15": "Convertire video TS in vari formati video/audio popolari",
      "product_info_2": "Copia DVD, converti video 4K, modifica e converti video in 5K/8K su Mac",
      "product_info_20": "Ripara i video danneggiati con elevata precisione e supporta molti formati su Mac",
      "product_info_6": "Converti qualsiasi video in MP3, MP4, MOV, WAV e altri 350 formati su Mac",
      "product_info_10": "Aumenta la risoluzione, ottimizza la luminosità e rimuovi il rumore video su Mac",
      "product_info_12": "Lo strumento più semplice per catturare schermate, giochi, audio, ecc. con alta qualità su Mac",
      "product_info_14": "Converti qualsiasi video 2D in video 3D e converti video 3D in 2D su Mac",
      "product_info_48": "Converti video 4K in 4K/1080P e video comuni su Mac",
      "product_info_16": "Convertire video TS in vari formati video/audio popolari su Mac",
      "product_info_46": "Copia e converti DVD in MP3 e supporta altri formati audio",
      "product_info_38": "Reimposta la password dell'account utente amministratore e standard di Windows in pochi secondi",
      "product_info_35": "Converti accuratamente qualsiasi file PDF in Word con OCR",
      "product_info_34": "Converti PDF in Word, Excel, HTML e Immagine con OCR",
      "product_info_44": "Rimuovi facilmente le filigrane da molti formati di file immagine gratuitamente online",
  },
  "ru": {
      "video": "Видео<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Утилита<i></i>",
      "pdf_tools": "PDF-инструменты<i></i>",
      "free_tools": "Бесплатные инструменты<i></i>",
      "other_tools": "Другие инструменты<i></i>",
      "free_online": "Бесплатно онлайн<i></i>",
      "desktop": "Рабочий стол<i></i>",
      "store": "Магазин Типард",
      "resource": "Ресурс",
      "points": "Очки:",
      "redeem": "Выкупать",
      "invite_friends_get_more_points": "Пригласите друзей и получите больше очков",
      "rewards_center": "Центр вознаграждений",
      "windows_software": "Программное обеспечение Windows<i></i>",
      "mac_software": "Программное обеспечение для Mac<i></i>",
      "product_1": "Видео Конвертер Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Тотальный Медиа Конвертер",
      "product_4": "Total Media Converter для Mac",
      "product_5": "Видео Конвертер",
      "product_6": "Видеоконвертер для Mac",
      "product_7": "Конвертер 4K UHD",
      "product_8": "Конвертер видео 4K для Mac",
      "product_9": "Видеоусилитель",
      "product_10": "Улучшатель видео для Mac",
      "product_11": "Снимок экрана",
      "product_12": "Захват экрана для Mac",
      "product_13": "3D-конвертер",
      "product_14": "3D-конвертер для Mac",
      "product_15": "Конвертер TS",
      "product_16": "Конвертер TS для Mac",
      "product_17": "Профессиональный захват экрана",
      "product_18": "Конвертер PPT в видео",
      "product_19": "FixMP4 - Ремонт видео",
      "product_20": "FixMP4 — восстановление видео для Mac",
      "product_21": "DVD-риппер",
      "product_22": "DVD-риппер для Mac",
      "product_23": "Создатель DVD",
      "product_24": "Создатель DVD для Mac",
      "product_25": "DVD-клонер",
      "product_26": "DVD Cloner для Mac",
      "product_27": "Blu-ray конвертер",
      "product_28": "Конвертер Blu-ray для Mac",
      "product_29": "Blu-ray-плеер",
      "product_30": "Blu-ray-плеер для Mac",
      "product_31": "Blu-ray-создатель",
      "product_32": "Blu-ray Копия",
      "product_33": "Набор инструментов Blu-ray",
      "product_34": "PDF-конвертер Платина",
      "product_35": "Конвертер PDF в Word",
      "product_36": "PDF-резчик",
      "product_37": "PDF-объединитель",
      "product_38": "Сброс пароля Windows",
      "product_39": "Восстановление данных",
      "product_40": "Передача iPhone",
      "product_41": "Восстановление данных iOS",
      "product_42": "Восстановление данных Android",
      "product_43": "Ластик для iPhone",
      "product_44": "Бесплатное онлайн-удаление водяных знаков",
      "product_45": "Бесплатный видеоредактор",
      "product_46": "Бесплатный конвертер DVD в MP3",
      "product_47": "Бесплатный конвертер PDF в BMP",
      "download_center": "Центр загрузки",
      "company": "Компания",
      "about": "О",
      "privacy_policy": "политика конфиденциальности",
      "terms_of_use": "Условия эксплуатации",
      "affiliate": "Партнер",
      "support_center": "Центр поддержки",
      "contact_us": "Связаться с нами",
      "support": "Поддерживать",
      "hot_products": "Горячие продукты",
      "follow_us": "Подписывайтесь на нас",
      "change_language": "Изменить язык",
      "product_48": "Конвертер 4K UHD для Mac",
      "blu-ray": "Blu-ray",
      "dvd": "ДВД",
      "video_1": "Видео",
      "utility_1": "Утилита",
      "desktop": "Рабочий стол",
      "online": "Онлайн",
      "view_all_product": "Просмотреть все продукты",
      "product_info_27": "Копируйте любимые фильмы и видео с Blu-ray/DVD в популярные форматы",
      "product_info_29": "Мощное программное обеспечение для воспроизведения видео и аудио Blu-ray/DVD",
      "product_info_31": "Создайте Blu-ray диск/папку/ISO-файл с вашим собственным видео",
      "product_info_32": "Резервное копирование/копирование ваших любимых Blu-ray на диск/в папку/в файлы iso",
      "product_info_28": "Копируйте любимые фильмы и видео с Blu-ray/DVD в популярные форматы на Mac",
      "product_info_30": "Мощное программное обеспечение для воспроизведения видео и аудио Blu-ray/DVD на Mac",
      "product_info_21": "Быстрое копирование DVD в любой популярный видеоформат с полным качеством",
      "product_info_23": "Создавайте DVD из видео и свободно записывайте видео на DVD/Blu-ray",
      "product_info_25": "Копировать DVD на DVD-диск/папку/ISO-файлы в соотношении 1:1",
      "product_info_22": "Быстрое копирование DVD в любой популярный видеоформат с полным качеством на Mac",
      "product_info_24": "Создавайте DVD из видео и свободно записывайте видео на DVD/Blu-ray на Mac",
      "product_info_26": "Копировать DVD на DVD-диск/папку/ISO-файлы в соотношении 1:1 на Mac",
      "product_info_1": "Копирование DVD, конвертация видео 4K, редактирование и масштабирование видео до 5K/8K",
      "product_info_19": "Восстанавливайте поврежденные видео с высокой точностью и поддерживайте множество форматов.",
      "product_info_5": "Конвертируйте любое видео в MP3, MP4, MOV, WAV и еще 350 форматов",
      "product_info_9": "Повысьте разрешение, оптимизируйте яркость и удалите видеошумы",
      "product_info_11": "Самый простой инструмент для захвата экрана, игры, звука и т. д. с высоким качеством",
      "product_info_13": "Конвертируйте любое 2D-видео в 3D-видео и конвертируйте 3D-видео в 2D-видео",
      "product_info_7": "Конвертируйте видео 4K в 4K/1080P и обычные видео",
      "product_info_15": "Конвертируйте TS-видео в различные популярные видео/аудиоформаты",
      "product_info_2": "Копирование DVD, конвертация видео 4K, редактирование и масштабирование видео до 5K/8K на Mac",
      "product_info_20": "Восстанавливайте поврежденные видео с высокой точностью и поддерживайте множество форматов на Mac",
      "product_info_6": "Конвертируйте любое видео в MP3, MP4, MOV, WAV и другие 350 форматов на Mac",
      "product_info_10": "Повышайте разрешение, оптимизируйте яркость и удаляйте видеошумы на Mac",
      "product_info_12": "Самый простой инструмент для захвата экрана, игры, звука и т. д. в высоком качестве на Mac",
      "product_info_14": "Конвертируйте любое 2D-видео в 3D-видео и конвертируйте 3D-видео в 2D-видео на Mac",
      "product_info_48": "Конвертируйте видео 4K в 4K/1080P и обычные видео на Mac",
      "product_info_16": "Конвертируйте TS-видео в различные популярные видео/аудиоформаты на Mac",
      "product_info_46": "Копируйте и конвертируйте DVD в MP3 и поддерживайте другие аудиоформаты",
      "product_info_38": "Сброс пароля учетной записи администратора и стандартного пользователя Windows за считанные секунды",
      "product_info_35": "Точно конвертируйте любой PDF-файл в Word с помощью OCR",
      "product_info_34": "Конвертируйте PDF в Word, Excel, HTML и изображения с помощью OCR",
      "product_info_44": "Легкое удаление водяных знаков из многих форматов файлов изображений бесплатно онлайн",
  },
  "tr": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Faydalılık<i></i>",
      "pdf_tools": "PDF Araçları<i></i>",
      "free_tools": "Ücretsiz Araçlar<i></i>",
      "other_tools": "Diğer Araçlar<i></i>",
      "free_online": "Ücretsiz Çevrimiçi<i></i>",
      "desktop": "Masaüstü<i></i>",
      "store": "Tipard Mağazası",
      "resource": "Kaynak",
      "points": "Puanlar:",
      "redeem": "Kurtarmak",
      "invite_friends_get_more_points": "Arkadaşlarınızı Davet Edin ve Daha Fazla Puan Kazanın",
      "rewards_center": "Ödül Merkezi",
      "windows_software": "Windows Yazılımı<i></i>",
      "mac_software": "Mac Yazılımı<i></i>",
      "product_1": "Video Dönüştürücü Ultimate",
      "product_2": "Mac Video Dönüştürücü Ultimate",
      "product_3": "Toplam Medya Dönüştürücü",
      "product_4": "Mac için Toplam Medya Dönüştürücü",
      "product_5": "Video dönüştürücü",
      "product_6": "Mac için Video Dönüştürücü",
      "product_7": "4K UHD Dönüştürücü",
      "product_8": "Mac için 4K Video Dönüştürücü",
      "product_9": "Video Güçlendirici",
      "product_10": "Mac Video Geliştirici",
      "product_11": "Ekran Görüntüsü",
      "product_12": "Mac için Ekran Görüntüsü Alma",
      "product_13": "3D Dönüştürücü",
      "product_14": "Mac için 3D Dönüştürücü",
      "product_15": "TS Dönüştürücü",
      "product_16": "Mac için TS Dönüştürücü",
      "product_17": "Ekran Yakalama Pro",
      "product_18": "PPT'den Video Dönüştürücü",
      "product_19": "FixMP4 - Video Onarımı",
      "product_20": "FixMP4 - Mac için Video Onarımı",
      "product_21": "DVD Kopyalayıcı",
      "product_22": "Mac için DVD Kopyalayıcı",
      "product_23": "DVD Yaratıcısı",
      "product_24": "Mac için DVD Oluşturucu",
      "product_25": "DVD Kopyalayıcı",
      "product_26": "Mac için DVD Kopyalayıcı",
      "product_27": "Blu-ray dönüştürücü",
      "product_28": "Mac için Blu-ray Dönüştürücü",
      "product_29": "Blu-ray Oynatıcı",
      "product_30": "Mac için Blu-ray Oynatıcı",
      "product_31": "Blu-ray Yaratıcısı",
      "product_32": "Blu-ray Kopyası",
      "product_33": "Blu-ray Araç Takımı",
      "product_34": "PDF Dönüştürücü Platin",
      "product_35": "PDF'den Word'e Dönüştürücü",
      "product_36": "PDF Kesici",
      "product_37": "PDF Birleştirici",
      "product_38": "Windows Parola Sıfırlama",
      "product_39": "Veri Kurtarma",
      "product_40": "iPhone Aktarımı",
      "product_41": "iOS Veri Kurtarma",
      "product_42": "Android Veri Kurtarma",
      "product_43": "iPhone Silgisi",
      "product_44": "Filigran Temizleyici Ücretsiz Çevrimiçi",
      "product_45": "Ücretsiz Video Editörü",
      "product_46": "Ücretsiz DVD'den MP3'e Dönüştürücü",
      "product_47": "Ücretsiz PDF'den BMP'ye Dönüştürücü",
      "download_center": "İndirme Merkezi",
      "company": "Şirket",
      "about": "Hakkında",
      "privacy_policy": "Gizlilik Politikası",
      "terms_of_use": "Kullanım Şartları",
      "affiliate": "Ortaklık",
      "support_center": "Destek Merkezi",
      "contact_us": "Bize Ulaşın",
      "support": "Destek",
      "hot_products": "Sıcak Ürünler",
      "follow_us": "Bizi takip edin",
      "change_language": "Dili değiştir",
      "product_48": "Mac için 4K UHD Dönüştürücü",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Video",
      "utility_1": "Faydalılık",
      "desktop": "Masaüstü",
      "online": "Çevrimiçi",
      "view_all_product": "Tüm Ürünleri Görüntüle",
      "product_info_27": "En sevdiğiniz Blu-ray/DVD filmlerini veya videolarını popüler formatlara kopyalayın",
      "product_info_29": "Blu-ray/DVD videolarını ve seslerini oynatmak için güçlü yazılım",
      "product_info_31": "Kendi videonuzla Blu-ray disk/klasör/ISO dosyası oluşturun",
      "product_info_32": "Favori Blu-ray'inizi diske/klasöre/iso dosyalarına yedekleyin/kopyalayın",
      "product_info_28": "En sevdiğiniz Blu-ray/DVD filmlerini veya videolarını Mac'te popüler formatlara dönüştürün",
      "product_info_30": "Mac'te Blu-ray/DVD videolarını ve seslerini oynatmak için güçlü yazılım",
      "product_info_21": "DVD'yi herhangi bir popüler video formatına tam kalitede hızlı bir şekilde kopyalayın",
      "product_info_23": "Videolardan DVD oluşturun ve videoyu DVD/Blu-ray'e özgürce yazın",
      "product_info_25": "DVD'yi DVD diskine/klasörüne/ISO dosyalarına 1:1 oranında kopyalayın",
      "product_info_22": "Mac'te DVD'yi herhangi bir popüler video formatına tam kalitede hızlı bir şekilde kopyalayın",
      "product_info_24": "Mac'te videolardan DVD oluşturun ve videoyu DVD/Blu-ray'e özgürce yazın",
      "product_info_26": "Mac'te DVD'yi DVD diske/klasöre/ISO dosyalarına 1:1 oranında kopyalayın",
      "product_info_1": "DVD'yi kopyalayın, 4K videoyu dönüştürün, düzenleyin ve videoları 5K/8K'ya yükseltin",
      "product_info_19": "Kırık videoları yüksek doğrulukla onarın ve birçok formatı destekleyin",
      "product_info_5": "Herhangi bir videoyu MP3, MP4, MOV, WAV ve diğer 350 formata dönüştürün",
      "product_info_9": "Çözünürlüğü yükseltin, parlaklığı optimize edin ve video gürültüsünü giderin",
      "product_info_11": "Ekran, oyun, ses vb.'yi yüksek kalitede yakalamak için en kolay araç",
      "product_info_13": "Herhangi bir 2D videoyu 3D videoya dönüştürün ve 3D'yi 2D videoya dönüştürün",
      "product_info_7": "4K videoyu 4K/1080P ve genel videolara dönüştürün",
      "product_info_15": "TS videosunu çeşitli popüler video/ses formatlarına dönüştürün",
      "product_info_2": "Mac'te DVD'yi kopyalayın, 4K videoyu dönüştürün, düzenleyin ve videoları 5K/8K'ya yükseltin",
      "product_info_20": "Kırık videoları yüksek doğrulukla onarın ve Mac'te birçok formatı destekleyin",
      "product_info_6": "Mac'te herhangi bir videoyu MP3, MP4, MOV, WAV ve diğer 350 formata dönüştürün",
      "product_info_10": "Mac'te çözünürlüğü yükseltin, parlaklığı optimize edin ve video gürültüsünü kaldırın",
      "product_info_12": "Mac'te ekran, oyun, ses vb.'yi yüksek kalitede yakalamak için en kolay araç",
      "product_info_14": "Herhangi bir 2D videoyu 3D videoya dönüştürün ve Mac'te 3D'yi 2D videoya dönüştürün",
      "product_info_48": "4K videoyu 4K/1080P'ye ve Mac'te yaygın videolara dönüştürme",
      "product_info_16": "TS videosunu Mac'te çeşitli popüler video/ses formatlarına dönüştürün",
      "product_info_46": "DVD'leri MP3'e dönüştürün ve diğer ses formatlarını destekleyin",
      "product_info_38": "Windows Admin ve Standart kullanıcı hesabı parolasını saniyeler içinde sıfırlayın",
      "product_info_35": "Herhangi bir PDF dosyasını OCR ile Word'e doğru şekilde dönüştürün",
      "product_info_34": "PDF'yi OCR ile Word, Excel, HTML ve Görüntüye dönüştürün",
      "product_info_44": "Birçok resim dosyası biçiminden filigranları kolayca ve ücretsiz olarak çevrimiçi kaldırın",
  },
  "ar": {
      "video": "فيديو<i></i>",
      "blu_ray_dvd": "بلو راي/دي في دي<i></i>",
      "utility": "جدوى<i></i>",
      "pdf_tools": "أدوات PDF<i></i>",
      "free_tools": "أدوات مجانية<i></i>",
      "other_tools": "أدوات أخرى<i></i>",
      "free_online": "مجاني على الانترنت<i></i>",
      "desktop": "سطح المكتب<i></i>",
      "store": "متجر تيبارد",
      "resource": "الموارد",
      "points": "نقاط:",
      "redeem": "يسترد",
      "invite_friends_get_more_points": "قم بدعوة الأصدقاء واحصل على المزيد من النقاط",
      "rewards_center": "مركز المكافآت",
      "windows_software": "برامج الويندوز<i></i>",
      "mac_software": "برامج ماك<i></i>",
      "product_1": "محول الفيديو النهائي",
      "product_2": "محول الفيديو لنظام Mac",
      "product_3": "محول الوسائط الكامل",
      "product_4": "برنامج Total Media Converter لنظام Mac",
      "product_5": "محول الفيديو",
      "product_6": "محول الفيديو لنظام التشغيل Mac",
      "product_7": "محول 4K UHD",
      "product_8": "محول فيديو 4K لنظام Mac",
      "product_9": "مُحسِّن الفيديو",
      "product_10": "مُحسِّن الفيديو لنظام Mac",
      "product_11": "التقاط الشاشة",
      "product_12": "التقاط الشاشة لنظام التشغيل Mac",
      "product_13": "محول ثلاثي الأبعاد",
      "product_14": "محول ثلاثي الأبعاد لنظام التشغيل Mac",
      "product_15": "محول TS",
      "product_16": "محول TS لنظام Mac",
      "product_17": "التقاط الشاشة الاحترافي",
      "product_18": "محول PPT إلى فيديو",
      "product_19": "FixMP4 - إصلاح الفيديو",
      "product_20": "FixMP4 - إصلاح الفيديو لنظام التشغيل Mac",
      "product_21": "برنامج نسخ أقراص DVD",
      "product_22": "برنامج نسخ أقراص DVD لنظام Mac",
      "product_23": "مُنشئ أقراص DVD",
      "product_24": "برنامج DVD Creator لنظام Mac",
      "product_25": "استنساخ أقراص DVD",
      "product_26": "برنامج استنساخ أقراص DVD لنظام Mac",
      "product_27": "محول بلو راي",
      "product_28": "محول Blu-ray لنظام Mac",
      "product_29": "مشغل بلو راي",
      "product_30": "مشغل بلو راي لنظام ماك",
      "product_31": "منشئ بلو راي",
      "product_32": "نسخة بلو راي",
      "product_33": "مجموعة أدوات بلو راي",
      "product_34": "محول PDF البلاتيني",
      "product_35": "محول PDF إلى Word",
      "product_36": "قاطع ملفات PDF",
      "product_37": "برنامج دمج ملفات PDF",
      "product_38": "إعادة تعيين كلمة مرور Windows",
      "product_39": "استعادة البيانات",
      "product_40": "نقل الايفون",
      "product_41": "استعادة بيانات iOS",
      "product_42": "استعادة بيانات الأندرويد",
      "product_43": "ممحاة الآيفون",
      "product_44": "إزالة العلامة المائية مجانًا عبر الإنترنت",
      "product_45": "محرر فيديو مجاني",
      "product_46": "محول DVD إلى MP3 مجاني",
      "product_47": "محول PDF إلى BMP مجاني",
      "download_center": "مركز التحميل",
      "company": "شركة",
      "about": "عن",
      "privacy_policy": "سياسة الخصوصية",
      "terms_of_use": "شروط الاستخدام",
      "affiliate": "الشريك",
      "support_center": "مركز الدعم",
      "contact_us": "اتصل بنا",
      "support": "يدعم",
      "hot_products": "المنتجات الساخنة",
      "follow_us": "تابعنا",
      "change_language": "تغيير اللغة",
      "product_48": "محول 4K UHD لنظام Mac",
      "blu-ray": "بلو راي",
      "dvd": "دي في دي",
      "video_1": "فيديو",
      "utility_1": "جدوى",
      "desktop": "سطح المكتب",
      "online": "متصل",
      "view_all_product": "عرض جميع المنتجات",
      "product_info_27": "قم بنسخ أفلامك أو مقاطع الفيديو المفضلة لديك من أقراص Blu-ray/DVD إلى التنسيقات الشائعة",
      "product_info_29": "برنامج قوي لتشغيل مقاطع الفيديو والصوت على أقراص Blu-ray/DVD",
      "product_info_31": "إنشاء قرص Blu-ray/مجلد/ملف ISO باستخدام الفيديو الخاص بك",
      "product_info_32": "النسخ الاحتياطي/نسخ أقراص Blu-ray المفضلة لديك إلى ملفات القرص/المجلد/iso",
      "product_info_28": "قم بنسخ أفلامك أو مقاطع الفيديو المفضلة لديك من أقراص Blu-ray/DVD إلى التنسيقات الشائعة على نظام التشغيل Mac",
      "product_info_30": "برنامج قوي لتشغيل مقاطع الفيديو والصوت Blu-ray/DVD على نظام Mac",
      "product_info_21": "تحويل قرص DVD إلى أي تنسيق فيديو شائع بسرعة وبجودة كاملة",
      "product_info_23": "إنشاء أقراص DVD من مقاطع الفيديو وحرق الفيديو على أقراص DVD/Blu-ray بحرية",
      "product_info_25": "نسخ أقراص DVD إلى أقراص DVD/مجلدات/ملفات ISO بنسبة 1:1",
      "product_info_22": "تحويل قرص DVD إلى أي تنسيق فيديو شائع بسرعة وبجودة كاملة على نظام التشغيل Mac",
      "product_info_24": "إنشاء قرص DVD من مقاطع الفيديو وحرق الفيديو على قرص DVD/Blu-ray بحرية على جهاز Mac",
      "product_info_26": "نسخ أقراص DVD إلى ملفات DVD/المجلد/ISO بنسبة 1:1 على نظام التشغيل Mac",
      "product_info_1": "استخراج أقراص DVD، وتحويل فيديو 4K، وتحرير مقاطع الفيديو وترقيتها إلى 5K/8K",
      "product_info_19": "إصلاح مقاطع الفيديو المعطوبة بدقة عالية ودعم العديد من التنسيقات",
      "product_info_5": "تحويل أي فيديو إلى MP3، MP4، MOV، WAV، وغيرها من تنسيقات 350",
      "product_info_9": "تحسين الدقة وتحسين السطوع وإزالة ضوضاء الفيديو",
      "product_info_11": "أسهل أداة لالتقاط الشاشة واللعبة والصوت وما إلى ذلك بجودة عالية",
      "product_info_13": "تحويل أي فيديو ثنائي الأبعاد إلى فيديو ثلاثي الأبعاد وتحويل الفيديو ثلاثي الأبعاد إلى فيديو ثنائي الأبعاد",
      "product_info_7": "تحويل فيديو 4K إلى 4K/1080P ومقاطع الفيديو الشائعة",
      "product_info_15": "تحويل فيديو TS إلى تنسيقات الفيديو/الصوت الشائعة المختلفة",
      "product_info_2": "استخراج أقراص DVD، وتحويل فيديو 4K، وتحرير مقاطع الفيديو وترقيتها إلى 5K/8K على نظام التشغيل Mac",
      "product_info_20": "إصلاح مقاطع الفيديو المعطوبة بدقة عالية ودعم العديد من التنسيقات على نظام التشغيل Mac",
      "product_info_6": "تحويل أي فيديو إلى MP3، MP4، MOV، WAV، وغيرها من التنسيقات 350 على جهاز Mac",
      "product_info_10": "تحسين الدقة وتحسين السطوع وإزالة ضوضاء الفيديو على جهاز Mac",
      "product_info_12": "أسهل أداة لالتقاط الشاشة واللعبة والصوت وما إلى ذلك بجودة عالية على نظام التشغيل Mac",
      "product_info_14": "تحويل أي فيديو ثنائي الأبعاد إلى فيديو ثلاثي الأبعاد وتحويل الفيديو ثلاثي الأبعاد إلى فيديو ثنائي الأبعاد على جهاز Mac",
      "product_info_48": "تحويل فيديو 4K إلى 4K/1080P ومقاطع الفيديو الشائعة على Mac",
      "product_info_16": "تحويل فيديو TS إلى تنسيقات الفيديو/الصوت الشائعة المختلفة على نظام التشغيل Mac",
      "product_info_46": "تمزيق وتحويل أقراص DVD إلى MP3 ودعم تنسيقات الصوت الأخرى",
      "product_info_38": "إعادة تعيين كلمة مرور حساب المسؤول والمستخدم القياسي في Windows في ثوانٍ",
      "product_info_35": "تحويل أي ملف PDF إلى Word بدقة باستخدام OCR",
      "product_info_34": "تحويل PDF إلى Word وExcel وHTML والصورة باستخدام OCR",
      "product_info_44": "قم بإزالة العلامات المائية بسهولة من العديد من تنسيقات ملفات الصور مجانًا عبر الإنترنت",
  },
  "pl": {
      "video": "Wideo<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Pożytek<i></i>",
      "pdf_tools": "Narzędzia PDF<i></i>",
      "free_tools": "Bezpłatne narzędzia<i></i>",
      "other_tools": "Inne narzędzia<i></i>",
      "free_online": "Bezpłatnie online<i></i>",
      "desktop": "Pulpit<i></i>",
      "store": "Sklep Tipard",
      "resource": "Ratunek",
      "points": "Zwrotnica:",
      "redeem": "Odkupić",
      "invite_friends_get_more_points": "Zaproś znajomych i zdobądź więcej punktów",
      "rewards_center": "Centrum nagród",
      "windows_software": "Oprogramowanie Windows<i></i>",
      "mac_software": "Oprogramowanie Mac<i></i>",
      "product_1": "Konwerter wideo Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Konwerter multimediów",
      "product_4": "Total Media Converter dla komputerów Mac",
      "product_5": "Konwerter wideo",
      "product_6": "Konwerter wideo dla komputerów Mac",
      "product_7": "Konwerter 4K UHD",
      "product_8": "Konwerter wideo 4K dla komputerów Mac",
      "product_9": "Wzmacniacz wideo",
      "product_10": "Mac Video Enhancer",
      "product_11": "Zrzut ekranu",
      "product_12": "Zrzut ekranu dla Maca",
      "product_13": "Konwerter 3D",
      "product_14": "Konwerter 3D dla komputerów Mac",
      "product_15": "Konwerter TS",
      "product_16": "Konwerter TS dla komputerów Mac",
      "product_17": "Zrzut ekranu Pro",
      "product_18": "Konwerter PPT na wideo",
      "product_19": "FixMP4 - Naprawa wideo",
      "product_20": "FixMP4 - Naprawa wideo dla komputerów Mac",
      "product_21": "Zgrywarka DVD",
      "product_22": "DVD Ripper dla Mac",
      "product_23": "Twórca DVD",
      "product_24": "DVD Creator dla komputerów Mac",
      "product_25": "Klonowanie DVD",
      "product_26": "DVD Cloner dla Mac",
      "product_27": "Konwerter Blu-ray",
      "product_28": "Konwerter Blu-ray dla komputerów Mac",
      "product_29": "Odtwarzacz Blu-ray",
      "product_30": "Odtwarzacz Blu-ray dla komputerów Mac",
      "product_31": "Twórca Blu-ray",
      "product_32": "Kopia Blu-ray",
      "product_33": "Zestaw narzędzi Blu-ray",
      "product_34": "Konwerter PDF Platinum",
      "product_35": "Konwerter PDF do Word",
      "product_36": "Obcinarka PDF",
      "product_37": "Łącznik PDF",
      "product_38": "Resetowanie hasła systemu Windows",
      "product_39": "Odzyskiwanie danych",
      "product_40": "Transfer iPhone'a",
      "product_41": "Odzyskiwanie danych iOS",
      "product_42": "Odzyskiwanie danych z Androida",
      "product_43": "Gumka do iPhone'a",
      "product_44": "Darmowy program do usuwania znaków wodnych online",
      "product_45": "Darmowy edytor wideo",
      "product_46": "Darmowy konwerter DVD na MP3",
      "product_47": "Darmowy konwerter PDF do BMP",
      "download_center": "Centrum pobierania",
      "company": "Firma",
      "about": "O",
      "privacy_policy": "Polityka prywatności",
      "terms_of_use": "Warunki korzystania",
      "affiliate": "Przyłączać",
      "support_center": "Centrum wsparcia",
      "contact_us": "Skontaktuj się z nami",
      "support": "Wsparcie",
      "hot_products": "Gorące produkty",
      "follow_us": "Obserwuj nas",
      "change_language": "Zmień język",
      "product_48": "Konwerter 4K UHD dla komputerów Mac",
      "blu-ray": "Blu-ray",
      "dvd": "płyta DVD",
      "video_1": "Wideo",
      "utility_1": "Pożytek",
      "desktop": "Pulpit",
      "online": "W sieci",
      "view_all_product": "Zobacz wszystkie produkty",
      "product_info_27": "Zgrywaj swoje ulubione filmy lub wideo z płyt Blu-ray/DVD do popularnych formatów",
      "product_info_29": "Potężne oprogramowanie do odtwarzania filmów i dźwięku Blu-ray/DVD",
      "product_info_31": "Utwórz płytę Blu-ray/folder/plik ISO z własnym filmem",
      "product_info_32": "Kopiuj/utwórz kopię zapasową ulubionej płyty Blu-ray na płytę/do folderu/pliki ISO",
      "product_info_28": "Zgrywaj swoje ulubione filmy Blu-ray/DVD lub wideo do popularnych formatów na komputerze Mac",
      "product_info_30": "Potężne oprogramowanie do odtwarzania filmów i dźwięku Blu-ray/DVD na komputerach Mac",
      "product_info_21": "Szybko zgrywaj DVD do dowolnego popularnego formatu wideo w pełnej jakości",
      "product_info_23": "Twórz płyty DVD z filmów i nagrywaj je swobodnie na płyty DVD/Blu-ray",
      "product_info_25": "Kopiuj DVD na płytę DVD/folder/pliki ISO w proporcjach 1:1",
      "product_info_22": "Szybko zgrywaj DVD do dowolnego popularnego formatu wideo w pełnej jakości na komputerze Mac",
      "product_info_24": "Twórz płyty DVD z filmów i nagrywaj je swobodnie na płyty DVD/Blu-ray na komputerach Mac",
      "product_info_26": "Kopiuj DVD na płytę DVD/folder/pliki ISO w proporcjach 1:1 na komputerze Mac",
      "product_info_1": "Zgrywaj DVD, konwertuj wideo 4K, edytuj i zwiększaj rozdzielczość filmów do 5K/8K",
      "product_info_19": "Naprawiaj uszkodzone filmy z dużą dokładnością i obsługuj wiele formatów",
      "product_info_5": "Konwertuj dowolny film do formatu MP3, MP4, MOV, WAV i 350 innych formatów",
      "product_info_9": "Zwiększ rozdzielczość, zoptymalizuj jasność i usuń szum wideo",
      "product_info_11": "Najprostsze narzędzie do przechwytywania ekranu, gier, dźwięku itp. w wysokiej jakości",
      "product_info_13": "Konwertuj dowolny film 2D na film 3D i konwertuj film 3D na film 2D",
      "product_info_7": "Konwertuj wideo 4K na 4K/1080P i popularne filmy",
      "product_info_15": "Konwertuj wideo TS do różnych popularnych formatów wideo/audio",
      "product_info_2": "Zgrywaj DVD, konwertuj wideo 4K, edytuj i zwiększaj rozdzielczość filmów do 5K/8K na komputerze Mac",
      "product_info_20": "Naprawiaj uszkodzone filmy z wysoką dokładnością i obsługuj wiele formatów na komputerach Mac",
      "product_info_6": "Konwertuj dowolny film do formatu MP3, MP4, MOV, WAV i innych 350 formatów na komputerze Mac",
      "product_info_10": "Zwiększ rozdzielczość, zoptymalizuj jasność i usuń szum wideo na komputerze Mac",
      "product_info_12": "Najłatwiejsze narzędzie do przechwytywania ekranu, gier, dźwięku itp. w wysokiej jakości na komputerach Mac",
      "product_info_14": "Konwertuj dowolny film 2D na film 3D i konwertuj film 3D na film 2D na komputerze Mac",
      "product_info_48": "Konwertuj wideo 4K na 4K/1080P i popularne filmy na komputerze Mac",
      "product_info_16": "Konwertuj wideo TS do różnych popularnych formatów wideo/audio na komputerze Mac",
      "product_info_46": "Zgrywaj i konwertuj płyty DVD do formatu MP3 i obsługuj inne formaty audio",
      "product_info_38": "Zresetuj hasło konta administratora systemu Windows i konta użytkownika standardowego w ciągu kilku sekund",
      "product_info_35": "Dokładnie konwertuj dowolny plik PDF do formatu Word za pomocą funkcji OCR",
      "product_info_34": "Konwertuj PDF do Worda, Excela, HTML i obrazu za pomocą OCR",
      "product_info_44": "Łatwe usuwanie znaków wodnych z wielu formatów plików graficznych za darmo online",
  },
  "nl": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Nutsvoorziening<i></i>",
      "pdf_tools": "PDF-hulpmiddelen<i></i>",
      "free_tools": "Gratis hulpmiddelen<i></i>",
      "other_tools": "Andere hulpmiddelen<i></i>",
      "free_online": "Gratis online<i></i>",
      "desktop": "Bureaublad<i></i>",
      "store": "Tipard-winkel",
      "resource": "Hulpbron",
      "points": "Punten:",
      "redeem": "Inwisselen",
      "invite_friends_get_more_points": "Nodig vrienden uit en ontvang meer punten",
      "rewards_center": "Beloningscentrum",
      "windows_software": "Windows-software<i></i>",
      "mac_software": "Mac-software<i></i>",
      "product_1": "Video Converter Ultieme",
      "product_2": "Mac Video Converter Ultiem",
      "product_3": "Totale mediaconverter",
      "product_4": "Total Media Converter voor Mac",
      "product_5": "Video-omzetter",
      "product_6": "Videoconverter voor Mac",
      "product_7": "4K UHD-converter",
      "product_8": "4K-videoconverter voor Mac",
      "product_9": "Video-verbeteraar",
      "product_10": "Mac-videoverbeteraar",
      "product_11": "Schermopname",
      "product_12": "Schermopname voor Mac",
      "product_13": "3D-converter",
      "product_14": "3D-converter voor Mac",
      "product_15": "TS-converter",
      "product_16": "TS Converter voor Mac",
      "product_17": "Schermopname Pro",
      "product_18": "PPT naar video-omzetter",
      "product_19": "FixMP4 - Videoreparatie",
      "product_20": "FixMP4 - Videoreparatie voor Mac",
      "product_21": "DVD-ripper",
      "product_22": "DVD Ripper voor Mac",
      "product_23": "DVD-maker",
      "product_24": "DVD Creator voor Mac",
      "product_25": "DVD-kloner",
      "product_26": "DVD Cloner voor Mac",
      "product_27": "Blu-ray-converter",
      "product_28": "Blu-ray-converter voor Mac",
      "product_29": "Blu-ray-speler",
      "product_30": "Blu-ray-speler voor Mac",
      "product_31": "Blu-ray-maker",
      "product_32": "Blu-ray-kopie",
      "product_33": "Blu-ray-toolkit",
      "product_34": "PDF-converter Platina",
      "product_35": "PDF naar Word-converter",
      "product_36": "PDF-snijder",
      "product_37": "PDF-samenvoeger",
      "product_38": "Windows-wachtwoord opnieuw instellen",
      "product_39": "Gegevensherstel",
      "product_40": "iPhone-overdracht",
      "product_41": "iOS-gegevensherstel",
      "product_42": "Android-gegevensherstel",
      "product_43": "iPhone-gum",
      "product_44": "Watermerkverwijderaar gratis online",
      "product_45": "Gratis video-editor",
      "product_46": "Gratis DVD naar MP3 converter",
      "product_47": "Gratis PDF naar BMP-converter",
      "download_center": "Downloadcentrum",
      "company": "Bedrijf",
      "about": "Over",
      "privacy_policy": "Privacybeleid",
      "terms_of_use": "Gebruiksvoorwaarden",
      "affiliate": "Partner",
      "support_center": "Ondersteuningscentrum",
      "contact_us": "Neem contact met ons op",
      "support": "Steun",
      "hot_products": "Populaire producten",
      "follow_us": "Volg ons",
      "change_language": "Taal wijzigen",
      "product_48": "4K UHD-converter voor Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Video",
      "utility_1": "Nutsvoorziening",
      "desktop": "Bureaublad",
      "online": "Online",
      "view_all_product": "Bekijk alle producten",
      "product_info_27": "Rip uw favoriete Blu-ray/DVD-films of video's naar populaire formaten",
      "product_info_29": "Krachtige software om Blu-ray/DVD-video's en audio af te spelen",
      "product_info_31": "Maak een Blu-ray-schijf/map/ISO-bestand met uw eigen video",
      "product_info_32": "Back-up/kopieer uw favoriete Blu-ray naar schijf/map/iso-bestanden",
      "product_info_28": "Rip uw favoriete Blu-ray/DVD-films of video's naar populaire formaten op Mac",
      "product_info_30": "Krachtige software om Blu-ray/DVD-video's en audio op Mac af te spelen",
      "product_info_21": "Rip DVD snel naar elk populair videoformaat met volledige kwaliteit",
      "product_info_23": "Maak DVD's van video's en brand video's gratis op DVD/Blu-ray",
      "product_info_25": "Kopieer DVD naar DVD-schijf/map/ISO-bestanden in een 1:1-verhouding",
      "product_info_22": "Rip DVD snel naar elk populair videoformaat met volledige kwaliteit op Mac",
      "product_info_24": "Maak DVD's van video's en brand video's gratis op DVD/Blu-ray op Mac",
      "product_info_26": "Kopieer DVD naar DVD-schijf/map/ISO-bestanden in een 1:1-verhouding op Mac",
      "product_info_1": "Rip DVD, converteer 4K-video, bewerk en schaal video's op naar 5K/8K",
      "product_info_19": "Herstel kapotte video's met hoge nauwkeurigheid en ondersteun veel formaten",
      "product_info_5": "Converteer elke video naar MP3, MP4, MOV, WAV en 350 andere formaten",
      "product_info_9": "Verhoog de resolutie, optimaliseer de helderheid en verwijder videoruis",
      "product_info_11": "De eenvoudigste tool om scherm, spel, audio, etc. vast te leggen met hoge kwaliteit",
      "product_info_13": "Converteer elke 2D-video naar 3D-video en converteer 3D naar 2D-video",
      "product_info_7": "Converteer 4K-video naar 4K/1080P en veelvoorkomende video's",
      "product_info_15": "Converteer TS-video naar verschillende populaire video-/audioformaten",
      "product_info_2": "Rip DVD, converteer 4K-video, bewerk en schaal video's op naar 5K/8K op Mac",
      "product_info_20": "Herstel kapotte video's met hoge nauwkeurigheid en ondersteun veel formaten op Mac",
      "product_info_6": "Converteer elke video naar MP3, MP4, MOV, WAV en 350 andere formaten op Mac",
      "product_info_10": "Verhoog de resolutie, optimaliseer de helderheid en verwijder videoruis op Mac",
      "product_info_12": "De eenvoudigste tool om scherm, game, audio, etc. met hoge kwaliteit vast te leggen op Mac",
      "product_info_14": "Converteer elke 2D-video naar 3D-video en converteer 3D naar 2D-video op Mac",
      "product_info_48": "Converteer 4K-video naar 4K/1080P en veelvoorkomende video's op Mac",
      "product_info_16": "Converteer TS-video naar verschillende populaire video-/audioformaten op Mac",
      "product_info_46": "Rip en converteer dvd's naar MP3 en ondersteun andere audioformaten",
      "product_info_38": "Windows Admin- en Standard-gebruikersaccountwachtwoorden in seconden opnieuw instellen",
      "product_info_35": "Converteer elk PDF-bestand nauwkeurig naar Word met OCR",
      "product_info_34": "Converteer PDF naar Word, Excel, HTML en afbeeldingen met OCR",
      "product_info_44": "Verwijder eenvoudig watermerken uit veel afbeeldingsbestandsformaten gratis online",
  },
  "sv": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Nytta<i></i>",
      "pdf_tools": "PDF-verktyg<i></i>",
      "free_tools": "Gratis verktyg<i></i>",
      "other_tools": "Andra verktyg<i></i>",
      "free_online": "Gratis online<i></i>",
      "desktop": "Skrivbord<i></i>",
      "store": "Tipard butik",
      "resource": "Resurs",
      "points": "Poäng:",
      "redeem": "Återlösa",
      "invite_friends_get_more_points": "Bjud in vänner och få fler poäng",
      "rewards_center": "Belöningscenter",
      "windows_software": "Windows-programvara<i></i>",
      "mac_software": "Mac-programvara<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Total Media Converter",
      "product_4": "Total Media Converter för Mac",
      "product_5": "Videokonverterare",
      "product_6": "Video Converter för Mac",
      "product_7": "4K UHD-omvandlare",
      "product_8": "4K Video Converter för Mac",
      "product_9": "Video Enhancer",
      "product_10": "Mac Video Enhancer",
      "product_11": "Skärmdump",
      "product_12": "Skärmdump för Mac",
      "product_13": "3D-omvandlare",
      "product_14": "3D-konverterare för Mac",
      "product_15": "TS omvandlare",
      "product_16": "TS Converter för Mac",
      "product_17": "Screen Capture Pro",
      "product_18": "PPT till videokonverterare",
      "product_19": "FixMP4 - Videoreparation",
      "product_20": "FixMP4 - Videoreparation för Mac",
      "product_21": "DVD Ripper",
      "product_22": "DVD Ripper för Mac",
      "product_23": "DVD Creator",
      "product_24": "DVD Creator för Mac",
      "product_25": "DVD Cloner",
      "product_26": "DVD Cloner för Mac",
      "product_27": "Blu-ray-omvandlare",
      "product_28": "Blu-ray-konverterare för Mac",
      "product_29": "Blu-ray-spelare",
      "product_30": "Blu-ray-spelare för Mac",
      "product_31": "Blu-ray Creator",
      "product_32": "Blu-ray kopia",
      "product_33": "Blu-ray Toolkit",
      "product_34": "PDF Converter Platinum",
      "product_35": "PDF till Word Converter",
      "product_36": "PDF Cutter",
      "product_37": "PDF-snickare",
      "product_38": "Windows lösenordsåterställning",
      "product_39": "Dataåterställning",
      "product_40": "iPhone Transfer",
      "product_41": "iOS Data Recovery",
      "product_42": "Android dataåterställning",
      "product_43": "iPhone suddgummi",
      "product_44": "Watermark Remover gratis online",
      "product_45": "Gratis videoredigerare",
      "product_46": "Gratis DVD till MP3 Converter",
      "product_47": "Gratis PDF till BMP Converter",
      "download_center": "Nedladdningscenter",
      "company": "Företag",
      "about": "Om",
      "privacy_policy": "Sekretesspolicy",
      "terms_of_use": "Användarvillkor",
      "affiliate": "Dotterbolag",
      "support_center": "Supportcenter",
      "contact_us": "Kontakta oss",
      "support": "Stöd",
      "hot_products": "Heta produkter",
      "follow_us": "Följ oss",
      "change_language": "Byt språk",
      "product_48": "4K UHD Converter för Mac",
      "blu-ray": "Blu-ray",
      "dvd": "dvd",
      "video_1": "Video",
      "utility_1": "Nytta",
      "desktop": "Skrivbord",
      "online": "Online",
      "view_all_product": "Se alla produkter",
      "product_info_27": "Rippa dina favorit Blu-ray/DVD-filmer eller videor till populära format",
      "product_info_29": "Kraftfull programvara för att spela Blu-ray/DVD-videor och ljud",
      "product_info_31": "Skapa Blu-ray-skiva/mapp/ISO-fil med din egen video",
      "product_info_32": "Säkerhetskopiera/kopiera din favorit Blu-ray till skiva/mapp/iso-filer",
      "product_info_28": "Rippa dina favorit Blu-ray/DVD-filmer eller -videor till populära format på Mac",
      "product_info_30": "Kraftfull programvara för att spela Blu-ray/DVD-videor och ljud på Mac",
      "product_info_21": "Rippa DVD till alla populära videoformat snabbt av full kvalitet",
      "product_info_23": "Skapa DVD från videor och bränn video till DVD/Blu-ray fritt",
      "product_info_25": "Kopiera DVD till DVD-skiva/mapp/ISO-filer i förhållandet 1:1",
      "product_info_22": "Rippa DVD till alla populära videoformat snabbt av full kvalitet på Mac",
      "product_info_24": "Skapa DVD från videor och bränn video till DVD/Blu-ray fritt på Mac",
      "product_info_26": "Kopiera DVD till DVD-skiva/mapp/ISO-filer i förhållandet 1:1 på Mac",
      "product_info_1": "Rippa DVD, konvertera 4K-video, redigera och uppskala videor till 5K/8K",
      "product_info_19": "Reparera trasiga videor med hög noggrannhet och stöder många format",
      "product_info_5": "Konvertera vilken video som helst till MP3, MP4, MOV, WAV och andra 350-format",
      "product_info_9": "Uppskala upplösning, optimera ljusstyrkan och ta bort videobrus",
      "product_info_11": "Det enklaste verktyget för att fånga skärm, spel, ljud etc. med hög kvalitet",
      "product_info_13": "Konvertera valfri 2D-video till 3D-video och konvertera 3D till 2D-video",
      "product_info_7": "Konvertera 4K-video till 4K/1080P och vanliga videor",
      "product_info_15": "Konvertera TS-video till olika populära video-/ljudformat",
      "product_info_2": "Rippa DVD, konvertera 4K-video, redigera och uppskala videor till 5K/8K på Mac",
      "product_info_20": "Reparera trasiga videor med hög noggrannhet och stöder många format på Mac",
      "product_info_6": "Konvertera vilken video som helst till MP3, MP4, MOV, WAV och andra 350-format på Mac",
      "product_info_10": "Uppskala upplösning, optimera ljusstyrkan och ta bort videobrus på Mac",
      "product_info_12": "Det enklaste verktyget för att fånga skärm, spel, ljud etc. med hög kvalitet på Mac",
      "product_info_14": "Konvertera valfri 2D-video till 3D-video och konvertera 3D till 2D-video på Mac",
      "product_info_48": "Konvertera 4K-video till 4K/1080P och vanliga videor på Mac",
      "product_info_16": "Konvertera TS-video till olika populära video-/ljudformat på Mac",
      "product_info_46": "Rippa och konvertera DVD-skivor till MP3 och stödja andra ljudformat",
      "product_info_38": "Återställ lösenordet för Windows Admin och Standard användarkonto på några sekunder",
      "product_info_35": "Konvertera alla PDF-filer till Word exakt med OCR",
      "product_info_34": "Konvertera PDF till Word, Excel, HTML och bild med OCR",
      "product_info_44": "Ta enkelt bort vattenstämplar från många bildfilformat gratis online",
  },
  "cs": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Utility<i></i>",
      "pdf_tools": "Nástroje PDF<i></i>",
      "free_tools": "Nástroje zdarma<i></i>",
      "other_tools": "Další nástroje<i></i>",
      "free_online": "Zdarma online<i></i>",
      "desktop": "Desktop<i></i>",
      "store": "Prodejna Tipard",
      "resource": "Zdroj",
      "points": "Body:",
      "redeem": "Vykoupit",
      "invite_friends_get_more_points": "Pozvěte přátele a získejte více bodů",
      "rewards_center": "Centrum odměn",
      "windows_software": "Software Windows<i></i>",
      "mac_software": "Software Mac<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Total Media Converter",
      "product_4": "Total Media Converter pro Mac",
      "product_5": "Video konvertor",
      "product_6": "Video Converter pro Mac",
      "product_7": "4K UHD převodník",
      "product_8": "4K Video Converter pro Mac",
      "product_9": "Video Enhancer",
      "product_10": "Mac Video Enhancer",
      "product_11": "Snímání obrazovky",
      "product_12": "Screen Capture pro Mac",
      "product_13": "3D převodník",
      "product_14": "3D konvertor pro Mac",
      "product_15": "TS převodník",
      "product_16": "TS Converter pro Mac",
      "product_17": "Screen Capture Pro",
      "product_18": "PPT to Video Converter",
      "product_19": "FixMP4 - Oprava videa",
      "product_20": "FixMP4 - Video Repair pro Mac",
      "product_21": "DVD Ripper",
      "product_22": "DVD Ripper pro Mac",
      "product_23": "DVD Creator",
      "product_24": "DVD Creator pro Mac",
      "product_25": "DVD Cloner",
      "product_26": "DVD Cloner pro Mac",
      "product_27": "Blu-ray konvertor",
      "product_28": "Blu-ray konvertor pro Mac",
      "product_29": "Blu-ray přehrávač",
      "product_30": "Blu-ray přehrávač pro Mac",
      "product_31": "Blu-ray Creator",
      "product_32": "Blu-ray kopie",
      "product_33": "Blu-ray Toolkit",
      "product_34": "PDF Converter Platinum",
      "product_35": "Konvertor PDF do Wordu",
      "product_36": "Vyřezávač PDF",
      "product_37": "PDF Joiner",
      "product_38": "Obnovení hesla systému Windows",
      "product_39": "Záchrana dat",
      "product_40": "Přenos iPhone",
      "product_41": "Obnova dat iOS",
      "product_42": "Záchrana dat pro Android",
      "product_43": "Eraser pro iPhone",
      "product_44": "Odstraňovač vodoznaků online zdarma",
      "product_45": "Zdarma Video Editor",
      "product_46": "Převaděč DVD do MP3 zdarma",
      "product_47": "Zdarma převodník PDF do BMP",
      "download_center": "Centrum stahování",
      "company": "Společnost",
      "about": "O",
      "privacy_policy": "Zásady ochrany osobních údajů",
      "terms_of_use": "Podmínky použití",
      "affiliate": "Přidružený",
      "support_center": "Centrum podpory",
      "contact_us": "Kontaktujte nás",
      "support": "Podpora",
      "hot_products": "Horké produkty",
      "follow_us": "Sledujte nás",
      "change_language": "Změnit jazyk",
      "product_48": "4K UHD převodník pro Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Video",
      "utility_1": "Utility",
      "desktop": "Desktop",
      "online": "Online",
      "view_all_product": "Zobrazit všechny produkty",
      "product_info_27": "Zkopírujte své oblíbené filmy nebo videa na Blu-ray/DVD do oblíbených formátů",
      "product_info_29": "Výkonný software pro přehrávání videa a zvuku Blu-ray/DVD",
      "product_info_31": "Vytvořte Blu-ray disk/složku/soubor ISO s vlastním videem",
      "product_info_32": "Zálohujte/zkopírujte své oblíbené Blu-ray na disk/složku/iso soubory",
      "product_info_28": "Kopírujte své oblíbené Blu-ray/DVD filmy nebo videa do oblíbených formátů na Macu",
      "product_info_30": "Výkonný software pro přehrávání Blu-ray/DVD videa a zvuku na Macu",
      "product_info_21": "Ripujte DVD do libovolného populárního video formátu rychle v plné kvalitě",
      "product_info_23": "Vytvářejte DVD z videí a volně vypalujte video na DVD/Blu-ray",
      "product_info_25": "Kopírování DVD na disk DVD/složku/soubory ISO v poměru 1:1",
      "product_info_22": "Ripujte DVD do libovolného populárního video formátu rychle v plné kvalitě na Macu",
      "product_info_24": "Vytvářejte DVD z videí a vypalujte video na DVD/Blu-ray volně na Macu",
      "product_info_26": "Zkopírujte DVD na disk DVD/složku/soubory ISO v poměru 1:1 na Macu",
      "product_info_1": "Ripujte DVD, převádějte 4K video, upravujte a upscale videa na 5K/8K",
      "product_info_19": "Opravte nefunkční videa s vysokou přesností a podporou mnoha formátů",
      "product_info_5": "Převeďte jakékoli video do MP3, MP4, MOV, WAV a dalších 350 formátů",
      "product_info_9": "Zvyšte rozlišení, optimalizujte jas a odstraňte šum videa",
      "product_info_11": "Nejjednodušší nástroj pro zachycení obrazovky, hry, zvuku atd. ve vysoké kvalitě",
      "product_info_13": "Převeďte jakékoli 2D video na 3D video a převeďte 3D na 2D video",
      "product_info_7": "Převeďte 4K video na 4K/1080P a běžná videa",
      "product_info_15": "Převeďte TS video do různých populárních video/audio formátů",
      "product_info_2": "Ripujte DVD, převádějte 4K video, upravujte a upscale videa na 5K/8K na Macu",
      "product_info_20": "Opravte nefunkční videa s vysokou přesností a podporujte mnoho formátů na Macu",
      "product_info_6": "Převeďte jakékoli video do MP3, MP4, MOV, WAV a dalších 350 formátů na Macu",
      "product_info_10": "Zvyšte rozlišení, optimalizujte jas a odstraňte šum videa na Macu",
      "product_info_12": "Nejjednodušší nástroj pro zachycení obrazovky, hry, zvuku atd. ve vysoké kvalitě na Macu",
      "product_info_14": "Převeďte jakékoli 2D video na 3D video a převeďte 3D na 2D video na Macu",
      "product_info_48": "Převeďte 4K video na 4K/1080P a běžná videa na Macu",
      "product_info_16": "Převeďte TS video do různých populárních video/audio formátů na Macu",
      "product_info_46": "Ripujte a převádějte DVD na MP3 a podporujte další zvukové formáty",
      "product_info_38": "Obnovení hesla správce systému Windows a standardního uživatelského účtu během několika sekund",
      "product_info_35": "Přesně převeďte jakýkoli soubor PDF do aplikace Word pomocí OCR",
      "product_info_34": "Převeďte PDF do Wordu, Excelu, HTML a obrázků pomocí OCR",
      "product_info_44": "Snadno odstraňte vodoznaky z mnoha formátů obrazových souborů zdarma online",
  },
  "da": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Utility<i></i>",
      "pdf_tools": "PDF-værktøjer<i></i>",
      "free_tools": "Gratis værktøjer<i></i>",
      "other_tools": "Andre værktøjer<i></i>",
      "free_online": "Gratis online<i></i>",
      "desktop": "Desktop<i></i>",
      "store": "Tipard Butik",
      "resource": "Ressource",
      "points": "Points:",
      "redeem": "Indløs",
      "invite_friends_get_more_points": "Inviter venner og få flere point",
      "rewards_center": "Belønningscenter",
      "windows_software": "Windows-software<i></i>",
      "mac_software": "Mac-software<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Total Media Converter",
      "product_4": "Total Media Converter til Mac",
      "product_5": "Video Converter",
      "product_6": "Video Converter til Mac",
      "product_7": "4K UHD konverter",
      "product_8": "4K Video Converter til Mac",
      "product_9": "Video Enhancer",
      "product_10": "Mac Video Enhancer",
      "product_11": "Skærmoptagelse",
      "product_12": "Skærmoptagelse til Mac",
      "product_13": "3D konverter",
      "product_14": "3D Converter til Mac",
      "product_15": "TS konverter",
      "product_16": "TS Converter til Mac",
      "product_17": "Screen Capture Pro",
      "product_18": "PPT til videokonverter",
      "product_19": "FixMP4 - Videoreparation",
      "product_20": "FixMP4 - Videoreparation til Mac",
      "product_21": "DVD Ripper",
      "product_22": "DVD Ripper til Mac",
      "product_23": "DVD Creator",
      "product_24": "DVD Creator til Mac",
      "product_25": "DVD Cloner",
      "product_26": "DVD Cloner til Mac",
      "product_27": "Blu-ray konverter",
      "product_28": "Blu-ray konverter til Mac",
      "product_29": "Blu-ray-afspiller",
      "product_30": "Blu-ray-afspiller til Mac",
      "product_31": "Blu-ray Creator",
      "product_32": "Blu-ray kopi",
      "product_33": "Blu-ray Toolkit",
      "product_34": "PDF Converter Platinum",
      "product_35": "Konverter pdf til word",
      "product_36": "PDF Cutter",
      "product_37": "PDF snedker",
      "product_38": "Windows Password Reset",
      "product_39": "Datagendannelse",
      "product_40": "iPhone overførsel",
      "product_41": "iOS-datagendannelse",
      "product_42": "Android datagendannelse",
      "product_43": "iPhone viskelæder",
      "product_44": "Vandmærkefjerner gratis online",
      "product_45": "Gratis video editor",
      "product_46": "Gratis DVD til MP3 Converter",
      "product_47": "Gratis PDF til BMP konverter",
      "download_center": "Downloadcenter",
      "company": "Selskab",
      "about": "Om",
      "privacy_policy": "Privatlivspolitik",
      "terms_of_use": "Vilkår for brug",
      "affiliate": "Affiliate",
      "support_center": "Supportcenter",
      "contact_us": "Kontakt os",
      "support": "Støtte",
      "hot_products": "Hotte produkter",
      "follow_us": "Følg os",
      "change_language": "Skift sprog",
      "product_48": "4K UHD Converter til Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Video",
      "utility_1": "Utility",
      "desktop": "Desktop",
      "online": "Online",
      "view_all_product": "Se alle produkter",
      "product_info_27": "Rip dine foretrukne Blu-ray/DVD-film eller -videoer til populære formater",
      "product_info_29": "Kraftig software til at afspille Blu-ray/DVD-videoer og lyd",
      "product_info_31": "Opret Blu-ray-disk/mappe/ISO-fil med din egen video",
      "product_info_32": "Sikkerhedskopier/kopiér din foretrukne Blu-ray til disk/mappe/iso-filer",
      "product_info_28": "Rip dine foretrukne Blu-ray/DVD-film eller -videoer til populære formater på Mac",
      "product_info_30": "Kraftig software til at afspille Blu-ray/DVD-videoer og lyd på Mac",
      "product_info_21": "Rip DVD til et hvilket som helst populært videoformat hurtigt i fuld kvalitet",
      "product_info_23": "Opret DVD fra videoer og brænd video til DVD/Blu-ray frit",
      "product_info_25": "Kopier DVD til DVD disk/mappe/ISO-filer i et 1:1-forhold",
      "product_info_22": "Rip DVD til et hvilket som helst populært videoformat hurtigt i fuld kvalitet på Mac",
      "product_info_24": "Opret DVD fra videoer og brænd video til DVD/Blu-ray frit på Mac",
      "product_info_26": "Kopier DVD til DVD disk/mappe/ISO-filer i et 1:1-forhold på Mac",
      "product_info_1": "Rip DVD, konverter 4K-video, rediger og opskaler videoer til 5K/8K",
      "product_info_19": "Reparer ødelagte videoer med høj nøjagtighed og understøtter mange formater",
      "product_info_5": "Konverter enhver video til MP3, MP4, MOV, WAV og andre 350-formater",
      "product_info_9": "Opskaler opløsning, optimer lysstyrken og fjern videostøj",
      "product_info_11": "Det nemmeste værktøj til at fange skærm, spil, lyd osv. med høj kvalitet",
      "product_info_13": "Konverter enhver 2D-video til 3D-video og konverter 3D til 2D-video",
      "product_info_7": "Konverter 4K-video til 4K/1080P og almindelige videoer",
      "product_info_15": "Konverter TS-video til forskellige populære video-/lydformater",
      "product_info_2": "Rip DVD, konverter 4K-video, rediger og opskaler videoer til 5K/8K på Mac",
      "product_info_20": "Reparer ødelagte videoer med høj nøjagtighed og understøtter mange formater på Mac",
      "product_info_6": "Konverter enhver video til MP3, MP4, MOV, WAV og andre 350-formater på Mac",
      "product_info_10": "Opskaler opløsning, optimer lysstyrken og fjern videostøj på Mac",
      "product_info_12": "Det nemmeste værktøj til at fange skærm, spil, lyd osv. med høj kvalitet på Mac",
      "product_info_14": "Konverter enhver 2D-video til 3D-video og konverter 3D til 2D-video på Mac",
      "product_info_48": "Konverter 4K-video til 4K/1080P og almindelige videoer på Mac",
      "product_info_16": "Konverter TS-video til forskellige populære video-/lydformater på Mac",
      "product_info_46": "Rip og konverter DVD'er til MP3 og understøtter andre lydformater",
      "product_info_38": "Nulstil Windows Admin og Standard brugerkontoadgangskode på få sekunder",
      "product_info_35": "Konverter nøjagtigt enhver PDF-fil til Word med OCR",
      "product_info_34": "Konverter PDF til Word, Excel, HTML og billede med OCR",
      "product_info_44": "Fjern nemt vandmærker fra mange billedfilformater gratis online",
  },
  "el": {
      "video": "Βίντεο<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Χρησιμότητα<i></i>",
      "pdf_tools": "Εργαλεία PDF<i></i>",
      "free_tools": "Δωρεάν Εργαλεία<i></i>",
      "other_tools": "Άλλα εργαλεία<i></i>",
      "free_online": "Δωρεάν Online<i></i>",
      "desktop": "Επιτραπέζιος υπολογιστής<i></i>",
      "store": "Κατάστημα Tipard",
      "resource": "Πόρος",
      "points": "Πόντοι:",
      "redeem": "Εξαργυρώνω",
      "invite_friends_get_more_points": "Προσκαλέστε φίλους και κερδίστε περισσότερους πόντους",
      "rewards_center": "Κέντρο Ανταμοιβών",
      "windows_software": "Λογισμικό Windows<i></i>",
      "mac_software": "Λογισμικό Mac<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Συνολικός μετατροπέας πολυμέσων",
      "product_4": "Total Media Converter για Mac",
      "product_5": "Μετατροπέας βίντεο",
      "product_6": "Μετατροπέας βίντεο για Mac",
      "product_7": "Μετατροπέας 4K UHD",
      "product_8": "Μετατροπέας βίντεο 4K για Mac",
      "product_9": "Βελτιωτή βίντεο",
      "product_10": "Mac Video Enhancer",
      "product_11": "Λήψη οθόνης",
      "product_12": "Λήψη οθόνης για Mac",
      "product_13": "Μετατροπέας 3D",
      "product_14": "Μετατροπέας 3D για Mac",
      "product_15": "Μετατροπέας TS",
      "product_16": "Μετατροπέας TS για Mac",
      "product_17": "Screen Capture Pro",
      "product_18": "Μετατροπέας PPT σε βίντεο",
      "product_19": "FixMP4 - Επισκευή βίντεο",
      "product_20": "FixMP4 - Επισκευή βίντεο για Mac",
      "product_21": "DVD Ripper",
      "product_22": "DVD Ripper για Mac",
      "product_23": "Δημιουργός DVD",
      "product_24": "DVD Creator για Mac",
      "product_25": "DVD Cloner",
      "product_26": "DVD Cloner για Mac",
      "product_27": "Μετατροπέας Blu-ray",
      "product_28": "Μετατροπέας Blu-ray για Mac",
      "product_29": "Blu-ray Player",
      "product_30": "Blu-ray Player για Mac",
      "product_31": "Δημιουργός Blu-ray",
      "product_32": "Αντιγραφή Blu-ray",
      "product_33": "Blu-ray Toolkit",
      "product_34": "Μετατροπέας PDF Platinum",
      "product_35": "Μετατροπέας PDF σε Word",
      "product_36": "Κόφτης PDF",
      "product_37": "PDF Joiner",
      "product_38": "Επαναφορά κωδικού πρόσβασης των Windows",
      "product_39": "Ανάκτηση δεδομένων",
      "product_40": "Μεταφορά iPhone",
      "product_41": "Ανάκτηση δεδομένων iOS",
      "product_42": "Ανάκτηση δεδομένων Android",
      "product_43": "Γόμα iPhone",
      "product_44": "Υδατογράφημα Αφαίρεσης Δωρεάν Online",
      "product_45": "Δωρεάν πρόγραμμα επεξεργασίας βίντεο",
      "product_46": "Δωρεάν μετατροπέας DVD σε MP3",
      "product_47": "Δωρεάν μετατροπέας PDF σε BMP",
      "download_center": "Κέντρο λήψης",
      "company": "Εταιρεία",
      "about": "Για",
      "privacy_policy": "Πολιτική Απορρήτου",
      "terms_of_use": "Όροι Χρήσης",
      "affiliate": "Εισδέχομαι μέλη",
      "support_center": "Κέντρο υποστήριξης",
      "contact_us": "Επικοινωνήστε μαζί μας",
      "support": "Υποστήριξη",
      "hot_products": "Καυτά προϊόντα",
      "follow_us": "Ακολουθήστε μας",
      "change_language": "Αλλαγή γλώσσας",
      "product_48": "Μετατροπέας 4K UHD για Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Βίντεο",
      "utility_1": "Χρησιμότητα",
      "desktop": "Επιτραπέζιος υπολογιστής",
      "online": "Διαδικτυακά",
      "view_all_product": "Δείτε όλα τα προϊόντα",
      "product_info_27": "Αντιγράψτε τις αγαπημένες σας ταινίες ή βίντεο Blu-ray/DVD σε δημοφιλείς μορφές",
      "product_info_29": "Ισχυρό λογισμικό για αναπαραγωγή βίντεο και ήχου Blu-ray/DVD",
      "product_info_31": "Δημιουργήστε δίσκο/φάκελο/αρχείο ISO Blu-ray με το δικό σας βίντεο",
      "product_info_32": "Δημιουργήστε αντίγραφα ασφαλείας/αντιγράψτε τα αγαπημένα σας Blu-ray σε αρχεία δίσκου/φάκελου/iso",
      "product_info_28": "Αντιγράψτε τις αγαπημένες σας ταινίες ή βίντεο Blu-ray/DVD σε δημοφιλείς μορφές σε Mac",
      "product_info_30": "Ισχυρό λογισμικό για αναπαραγωγή βίντεο και ήχου Blu-ray/DVD σε Mac",
      "product_info_21": "Αντιγράψτε γρήγορα το DVD σε οποιαδήποτε δημοφιλή μορφή βίντεο πλήρους ποιότητας",
      "product_info_23": "Δημιουργήστε DVD από βίντεο και εγγραφή βίντεο σε DVD/Blu-ray ελεύθερα",
      "product_info_25": "Αντιγράψτε DVD σε δίσκο DVD/φάκελο/αρχεία ISO σε αναλογία 1:1",
      "product_info_22": "Αντιγράψτε το DVD σε οποιαδήποτε δημοφιλή μορφή βίντεο γρήγορα σε πλήρη ποιότητα σε Mac",
      "product_info_24": "Δημιουργήστε DVD από βίντεο και εγγραφή βίντεο σε DVD/Blu-ray ελεύθερα σε Mac",
      "product_info_26": "Αντιγράψτε DVD σε δίσκο DVD/φάκελο/ αρχεία ISO σε αναλογία 1:1 σε Mac",
      "product_info_1": "Αντιγράψτε το DVD, μετατρέψτε βίντεο 4K, επεξεργαστείτε και αναβαθμίστε βίντεο σε 5K/8K",
      "product_info_19": "Επισκευάστε σπασμένα βίντεο με υψηλή ακρίβεια και υποστηρίξτε πολλές μορφές",
      "product_info_5": "Μετατρέψτε οποιοδήποτε βίντεο σε MP3, MP4, MOV, WAV και άλλες μορφές 350",
      "product_info_9": "Αναβαθμίστε την ανάλυση, βελτιστοποιήστε τη φωτεινότητα και αφαιρέστε το θόρυβο βίντεο",
      "product_info_11": "Το πιο εύκολο εργαλείο για λήψη οθόνης, παιχνιδιού, ήχου κ.λπ. με υψηλή ποιότητα",
      "product_info_13": "Μετατρέψτε οποιοδήποτε βίντεο 2D σε βίντεο 3D και μετατρέψτε βίντεο 3D σε 2D",
      "product_info_7": "Μετατρέψτε βίντεο 4K σε 4K/1080P και κοινά βίντεο",
      "product_info_15": "Μετατρέψτε το βίντεο TS σε διάφορες δημοφιλείς μορφές βίντεο/ήχου",
      "product_info_2": "Αντιγράψτε το DVD, μετατρέψτε βίντεο 4K, επεξεργαστείτε και αναβαθμίστε τα βίντεο σε 5K/8K σε Mac",
      "product_info_20": "Επισκευάστε σπασμένα βίντεο με υψηλή ακρίβεια και υποστηρίξτε πολλές μορφές σε Mac",
      "product_info_6": "Μετατρέψτε οποιοδήποτε βίντεο σε MP3, MP4, MOV, WAV και άλλες μορφές 350 σε Mac",
      "product_info_10": "Αναβαθμίστε την ανάλυση, βελτιστοποιήστε τη φωτεινότητα και αφαιρέστε το θόρυβο βίντεο σε Mac",
      "product_info_12": "Το πιο εύκολο εργαλείο για λήψη οθόνης, παιχνιδιού, ήχου κ.λπ. με υψηλή ποιότητα σε Mac",
      "product_info_14": "Μετατρέψτε οποιοδήποτε βίντεο 2D σε βίντεο 3D και μετατρέψτε βίντεο 3D σε 2D σε Mac",
      "product_info_48": "Μετατρέψτε βίντεο 4K σε 4K/1080P και κοινά βίντεο σε Mac",
      "product_info_16": "Μετατρέψτε το βίντεο TS σε διάφορες δημοφιλείς μορφές βίντεο/ήχου σε Mac",
      "product_info_46": "Αντιγραφή και μετατροπή DVD σε MP3 και υποστήριξη άλλων μορφών ήχου",
      "product_info_38": "Επαναφέρετε τον κωδικό πρόσβασης διαχειριστή και τυπικού λογαριασμού χρήστη των Windows σε δευτερόλεπτα",
      "product_info_35": "Μετατρέψτε με ακρίβεια οποιοδήποτε αρχείο PDF σε Word με OCR",
      "product_info_34": "Μετατρέψτε το PDF σε Word, Excel, HTML και Εικόνα με OCR",
      "product_info_44": "Καταργήστε εύκολα τα υδατογραφήματα από πολλές μορφές αρχείων εικόνας δωρεάν online",
  },
  "fi": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Apuohjelma<i></i>",
      "pdf_tools": "PDF-työkalut<i></i>",
      "free_tools": "Ilmaiset työkalut<i></i>",
      "other_tools": "Muut työkalut<i></i>",
      "free_online": "Ilmainen Online<i></i>",
      "desktop": "Työpöytä<i></i>",
      "store": "Tipard Store",
      "resource": "Resurssi",
      "points": "Pisteet:",
      "redeem": "Lunastaa",
      "invite_friends_get_more_points": "Kutsu ystäviä ja hanki lisää pisteitä",
      "rewards_center": "Palkintokeskus",
      "windows_software": "Windows-ohjelmisto<i></i>",
      "mac_software": "Mac-ohjelmisto<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Total Media Converter",
      "product_4": "Total Media Converter for Mac",
      "product_5": "Video Converter",
      "product_6": "Video Converter for Mac",
      "product_7": "4K UHD muunnin",
      "product_8": "4K Video Converter for Mac",
      "product_9": "Videon tehostin",
      "product_10": "Mac Video Enhancer",
      "product_11": "Screen Capture",
      "product_12": "Näytönkaappaus Macille",
      "product_13": "3D-muunnin",
      "product_14": "3D Converter for Mac",
      "product_15": "TS-muunnin",
      "product_16": "TS Converter for Mac",
      "product_17": "Screen Capture Pro",
      "product_18": "PPT-videomuunnin",
      "product_19": "FixMP4 - Videon korjaus",
      "product_20": "FixMP4 - Videon korjaus Macille",
      "product_21": "DVD Ripper",
      "product_22": "DVD Ripper Macille",
      "product_23": "DVD Creator",
      "product_24": "DVD Creator for Mac",
      "product_25": "DVD Cloner",
      "product_26": "DVD Cloner Macille",
      "product_27": "Blu-ray-muunnin",
      "product_28": "Blu-ray-muunnin Macille",
      "product_29": "Blu-ray-soitin",
      "product_30": "Blu-ray-soitin Macille",
      "product_31": "Blu-ray Creator",
      "product_32": "Blu-ray kopio",
      "product_33": "Blu-ray Toolkit",
      "product_34": "PDF Converter Platinum",
      "product_35": "PDF-muunnin Wordiksi",
      "product_36": "PDF-leikkuri",
      "product_37": "PDF-puuseppä",
      "product_38": "Windowsin salasanan palautus",
      "product_39": "Tietojen palautus",
      "product_40": "iPhonen siirto",
      "product_41": "iOS-tietojen palautus",
      "product_42": "Android-tietojen palautus",
      "product_43": "iPhonen pyyhekumi",
      "product_44": "Vesileimanpoistoaine ilmaiseksi verkossa",
      "product_45": "Ilmainen videoeditori",
      "product_46": "Ilmainen DVD-MP3-muunnin",
      "product_47": "Ilmainen PDF to BMP Converter",
      "download_center": "Latauskeskus",
      "company": "Yritys",
      "about": "Noin",
      "privacy_policy": "Tietosuojakäytäntö",
      "terms_of_use": "Käyttöehdot",
      "affiliate": "Yhteistyökumppani",
      "support_center": "Tukikeskus",
      "contact_us": "Ota yhteyttä",
      "support": "Tukea",
      "hot_products": "Kuumat tuotteet",
      "follow_us": "Seuraa meitä",
      "change_language": "Vaihda kieli",
      "product_48": "4K UHD Converter Macille",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Video",
      "utility_1": "Apuohjelma",
      "desktop": "Työpöytä",
      "online": "verkossa",
      "view_all_product": "Näytä kaikki tuotteet",
      "product_info_27": "Kopioi suosikki Blu-ray/DVD-elokuvasi tai -videosi suosittuihin muotoihin",
      "product_info_29": "Tehokas ohjelmisto Blu-ray/DVD-videoiden ja äänen toistamiseen",
      "product_info_31": "Luo Blu-ray-levy/kansio/ISO-tiedosto omalla videollasi",
      "product_info_32": "Varmuuskopioi/kopioi suosikki Blu-ray levylle/kansioon/iso-tiedostoihin",
      "product_info_28": "Kopioi suosikki Blu-ray-/DVD-elokuvasi tai -videosi suosittuihin muotoihin Macissa",
      "product_info_30": "Tehokas ohjelmisto Blu-ray/DVD-videoiden ja äänen toistamiseen Macilla",
      "product_info_21": "Kopioi DVD mihin tahansa suosittuun videomuotoon nopeasti täydellä laadulla",
      "product_info_23": "Luo DVD videoista ja polta videoita DVD-/Blu-ray-levyille vapaasti",
      "product_info_25": "Kopioi DVD DVD-levylle/kansiolle/ISO-tiedostoille suhteessa 1:1",
      "product_info_22": "Kopioi DVD mihin tahansa suosittuun videomuotoon nopeasti täydellä laadulla Macissa",
      "product_info_24": "Luo DVD videoista ja polta videoita DVD-/Blu-ray-levyille vapaasti Macissa",
      "product_info_26": "Kopioi DVD DVD-levylle/kansiolle/ISO-tiedostoille suhteessa 1:1 Macissa",
      "product_info_1": "Kopioi DVD, muunna 4K-video, muokkaa ja paranna videoita 5K/8K-laatuisiksi",
      "product_info_19": "Korjaa rikkinäiset videot suurella tarkkuudella ja tue monia formaatteja",
      "product_info_5": "Muunna mikä tahansa video MP3-, MP4-, MOV-, WAV- ja muihin 350-muotoihin",
      "product_info_9": "Paras resoluutio, optimoi kirkkaus ja poista videokohina",
      "product_info_11": "Helpoin työkalu näytön, pelin, äänen jne. kaappaamiseen laadukkaasti",
      "product_info_13": "Muunna mikä tahansa 2D-video 3D-videoksi ja muunna 3D-video 2D-videoksi",
      "product_info_7": "Muunna 4K-video 4K/1080P:ksi ja yleisimmät videot",
      "product_info_15": "Muunna TS-video useisiin suosittuihin video-/äänimuotoihin",
      "product_info_2": "Kopioi DVD, muunna 4K-video, muokkaa ja paranna videoita 5K/8K-laatuisiksi Macilla",
      "product_info_20": "Korjaa rikkinäiset videot suurella tarkkuudella ja tue monia formaatteja Macissa",
      "product_info_6": "Muunna mikä tahansa video MP3-, MP4-, MOV-, WAV- ja muihin 350-muotoihin Macissa",
      "product_info_10": "Paras tarkkuus, optimoi kirkkaus ja poista videokohina Macissa",
      "product_info_12": "Helpoin työkalu näytön, pelin, äänen jne. kaappaamiseen korkealaatuisella Macilla",
      "product_info_14": "Muunna mikä tahansa 2D-video 3D-videoksi ja muunna 3D-video 2D-videoksi Macissa",
      "product_info_48": "Muunna 4K-video 4K/1080P:ksi ja tavallisimmat videot Macissa",
      "product_info_16": "Muunna TS-video useisiin suosittuihin video-/äänimuotoihin Macissa",
      "product_info_46": "Kopioi ja muunna DVD-levyjä MP3-muotoon ja tue muita äänimuotoja",
      "product_info_38": "Palauta Windows Admin- ja Standard-käyttäjätilin salasana sekunneissa",
      "product_info_35": "Muunna kaikki PDF-tiedostot tarkasti Wordiksi OCR:n avulla",
      "product_info_34": "Muunna PDF Wordiksi, Exceliksi, HTML:ksi ja kuvaksi OCR:llä",
      "product_info_44": "Poista vesileimat helposti monista kuvatiedostomuodoista ilmaiseksi verkossa",
  },
  "hu": {
      "video": "Videó<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Hasznosság<i></i>",
      "pdf_tools": "PDF-eszközök<i></i>",
      "free_tools": "Ingyenes eszközök<i></i>",
      "other_tools": "Egyéb eszközök<i></i>",
      "free_online": "Ingyenes online<i></i>",
      "desktop": "Asztali<i></i>",
      "store": "Tipard Store",
      "resource": "Forrás",
      "points": "Pontok:",
      "redeem": "Beváltani",
      "invite_friends_get_more_points": "Hívjon meg barátokat és szerezzen több pontot",
      "rewards_center": "Jutalomközpont",
      "windows_software": "Windows szoftver<i></i>",
      "mac_software": "Mac szoftver<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Total Media Converter",
      "product_4": "Total Media Converter for Mac",
      "product_5": "Video Converter",
      "product_6": "Video Converter for Mac",
      "product_7": "4K UHD konverter",
      "product_8": "4K Video Converter for Mac",
      "product_9": "Video Enhancer",
      "product_10": "Mac Video Enhancer",
      "product_11": "Képernyőfelvétel",
      "product_12": "Screen Capture for Mac",
      "product_13": "3D konverter",
      "product_14": "3D Converter for Mac",
      "product_15": "TS konverter",
      "product_16": "TS Converter for Mac",
      "product_17": "Screen Capture Pro",
      "product_18": "PPT-ből Video Converter",
      "product_19": "FixMP4 – Videójavítás",
      "product_20": "FixMP4 – Videójavítás Mac-hez",
      "product_21": "DVD Ripper",
      "product_22": "DVD Ripper Mac-hez",
      "product_23": "DVD-készítő",
      "product_24": "DVD Creator for Mac",
      "product_25": "DVD klónozó",
      "product_26": "DVD Cloner for Mac",
      "product_27": "Blu-ray konverter",
      "product_28": "Blu-ray konverter Machez",
      "product_29": "Blu-ray lejátszó",
      "product_30": "Blu-ray lejátszó Machez",
      "product_31": "Blu-ray Creator",
      "product_32": "Blu-ray másolás",
      "product_33": "Blu-ray Toolkit",
      "product_34": "PDF Converter Platina",
      "product_35": "PDF-ből Word konvertáló",
      "product_36": "PDF vágó",
      "product_37": "PDF Asztalos",
      "product_38": "Windows jelszó visszaállítása",
      "product_39": "Adatmentés",
      "product_40": "iPhone átvitel",
      "product_41": "iOS adat-helyreállítás",
      "product_42": "Android Data Recovery",
      "product_43": "iPhone radír",
      "product_44": "Vízjel eltávolító ingyenes online",
      "product_45": "Ingyenes videószerkesztő",
      "product_46": "Ingyenes DVD-MP3 konverter",
      "product_47": "Ingyenes PDF-ből BMP konvertáló",
      "download_center": "Letöltő központ",
      "company": "Vállalat",
      "about": "Körülbelül",
      "privacy_policy": "Adatvédelmi szabályzat",
      "terms_of_use": "Felhasználási feltételek",
      "affiliate": "Leányvállalat",
      "support_center": "Támogatási Központ",
      "contact_us": "Lépjen kapcsolatba velünk",
      "support": "Támogatás",
      "hot_products": "Forró termékek",
      "follow_us": "Kövess minket",
      "change_language": "Nyelv módosítása",
      "product_48": "4K UHD konverter Machez",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Videó",
      "utility_1": "Hasznosság",
      "desktop": "Asztali",
      "online": "Online",
      "view_all_product": "Összes termék megtekintése",
      "product_info_27": "Másolja kedvenc Blu-ray/DVD-filmjeit vagy videóit népszerű formátumokba",
      "product_info_29": "Hatékony szoftver Blu-ray/DVD videók és hangok lejátszásához",
      "product_info_31": "Hozzon létre Blu-ray lemezt/mappát/ISO fájlt saját videójával",
      "product_info_32": "Mentse/másolja kedvenc Blu-ray-ját lemezre/mappába/iso fájlokra",
      "product_info_28": "Másolja kedvenc Blu-ray/DVD-filmjeit vagy videóit népszerű formátumba Mac számítógépen",
      "product_info_30": "Hatékony szoftver Blu-ray/DVD videók és hangok lejátszásához Mac számítógépen",
      "product_info_21": "Másolja a DVD-t bármilyen népszerű videoformátumra gyorsan teljes minőségben",
      "product_info_23": "Készítsen DVD-t videókból, és írjon videót DVD-re/Blu-ray-re szabadon",
      "product_info_25": "Másoljon DVD-t DVD-lemezre/mappára/ISO-fájlokra 1:1 arányban",
      "product_info_22": "Másoljon DVD-t bármilyen népszerű videoformátumba gyorsan teljes minőségben Mac rendszeren",
      "product_info_24": "Készítsen DVD-t videókból, és írjon videót DVD-re/Blu-ray-re szabadon Macen",
      "product_info_26": "Másoljon DVD-t DVD-lemezre/mappába/ISO-fájlokra 1:1 arányban Mac gépen",
      "product_info_1": "Másoljon DVD-t, konvertáljon 4K-s videókat, szerkessze és feljavítsa a videókat 5K/8K-ra",
      "product_info_19": "Javítsa meg nagy pontossággal a törött videókat, és számos formátumot támogat",
      "product_info_5": "Bármilyen videót konvertálhat MP3, MP4, MOV, WAV és egyéb 350 formátumokká",
      "product_info_9": "Növelje a felbontást, optimalizálja a fényerőt és távolítsa el a videózajt",
      "product_info_11": "A legegyszerűbb eszköz képernyő, játék, hang stb. kiváló minőségű rögzítésére",
      "product_info_13": "Konvertáljon bármilyen 2D videót 3D videóvá, és alakítson át 3D-t 2D videóvá",
      "product_info_7": "Konvertálja a 4K-s videót 4K/1080P-re és a szokásos videókat",
      "product_info_15": "Konvertálja a TS videót különböző népszerű video-/audioformátumokká",
      "product_info_2": "Másoljon DVD-t, konvertáljon 4K-s videókat, szerkessze és javítsa fel a videókat 5K/8K-s formátumra Macen",
      "product_info_20": "Javítsa meg nagy pontossággal a törött videókat, és támogasson számos formátumot Macen",
      "product_info_6": "Bármilyen videót konvertálhat MP3, MP4, MOV, WAV és más 350 formátumokká Mac számítógépen",
      "product_info_10": "Előkelő felbontás, optimalizálja a fényerőt és távolítsa el a videozajt Macen",
      "product_info_12": "A legegyszerűbb eszköz képernyő, játék, hang stb. rögzítésére kiváló minőségben Mac rendszeren",
      "product_info_14": "Bármely 2D videót konvertálhat 3D videóvá, és konvertálhat 3D-t 2D videóvá Mac rendszeren",
      "product_info_48": "Konvertálja a 4K-s videót 4K/1080P-vé és a gyakori videókat Mac-en",
      "product_info_16": "Konvertálja a TS videót különböző népszerű video-/audioformátumokká Mac rendszeren",
      "product_info_46": "DVD-k másolása és konvertálása MP3 formátumba, valamint más audioformátumok támogatása",
      "product_info_38": "Állítsa vissza a Windows rendszergazdai és normál felhasználói fiók jelszavát másodpercek alatt",
      "product_info_35": "Pontosan konvertáljon bármilyen PDF-fájlt Word-be az OCR segítségével",
      "product_info_34": "PDF konvertálása Word, Excel, HTML és kép formátumba az OCR segítségével",
      "product_info_44": "Könnyen eltávolíthatja a vízjeleket számos képfájlformátumból ingyenesen online",
  },
  "no": {
      "video": "Video<i></i>",
      "blu_ray_dvd": "Blu-ray/DVD<i></i>",
      "utility": "Utility<i></i>",
      "pdf_tools": "PDF-verktøy<i></i>",
      "free_tools": "Gratis verktøy<i></i>",
      "other_tools": "Andre verktøy<i></i>",
      "free_online": "Gratis på nett<i></i>",
      "desktop": "Skrivebord<i></i>",
      "store": "Tipard Store",
      "resource": "Ressurs",
      "points": "Poeng:",
      "redeem": "Løs inn",
      "invite_friends_get_more_points": "Inviter venner og få flere poeng",
      "rewards_center": "Belønningssenter",
      "windows_software": "Windows-programvare<i></i>",
      "mac_software": "Mac-programvare<i></i>",
      "product_1": "Video Converter Ultimate",
      "product_2": "Mac Video Converter Ultimate",
      "product_3": "Total Media Converter",
      "product_4": "Total Media Converter for Mac",
      "product_5": "Video Converter",
      "product_6": "Video Converter for Mac",
      "product_7": "4K UHD-konverter",
      "product_8": "4K Video Converter for Mac",
      "product_9": "Video Enhancer",
      "product_10": "Mac Video Enhancer",
      "product_11": "Skjermfangst",
      "product_12": "Skjermopptak for Mac",
      "product_13": "3D-konverter",
      "product_14": "3D Converter for Mac",
      "product_15": "TS-konverter",
      "product_16": "TS Converter for Mac",
      "product_17": "Screen Capture Pro",
      "product_18": "PPT til Video Converter",
      "product_19": "FixMP4 - Videoreparasjon",
      "product_20": "FixMP4 - Videoreparasjon for Mac",
      "product_21": "DVD Ripper",
      "product_22": "DVD Ripper for Mac",
      "product_23": "DVD Creator",
      "product_24": "DVD Creator for Mac",
      "product_25": "DVD Cloner",
      "product_26": "DVD Cloner for Mac",
      "product_27": "Blu-ray-konverter",
      "product_28": "Blu-ray Converter for Mac",
      "product_29": "Blu-ray-spiller",
      "product_30": "Blu-ray-spiller for Mac",
      "product_31": "Blu-ray Creator",
      "product_32": "Blu-ray kopi",
      "product_33": "Blu-ray Toolkit",
      "product_34": "PDF Converter Platinum",
      "product_35": "Konverter PDF til Word",
      "product_36": "PDF-kutter",
      "product_37": "PDF snekker",
      "product_38": "Tilbakestill Windows-passord",
      "product_39": "Datagjenoppretting",
      "product_40": "iPhone-overføring",
      "product_41": "iOS-datagjenoppretting",
      "product_42": "Android datagjenoppretting",
      "product_43": "iPhone viskelær",
      "product_44": "Vannmerkefjerner gratis på nett",
      "product_45": "Gratis videoredigerer",
      "product_46": "Gratis DVD til MP3 Converter",
      "product_47": "Gratis PDF til BMP Converter",
      "download_center": "Nedlastingssenter",
      "company": "Bedrift",
      "about": "Om",
      "privacy_policy": "Personvernerklæring",
      "terms_of_use": "Vilkår for bruk",
      "affiliate": "Affiliate",
      "support_center": "Støttesenter",
      "contact_us": "Kontakt oss",
      "support": "Støtte",
      "hot_products": "Varme produkter",
      "follow_us": "Følg oss",
      "change_language": "Endre språk",
      "product_48": "4K UHD Converter for Mac",
      "blu-ray": "Blu-ray",
      "dvd": "DVD",
      "video_1": "Video",
      "utility_1": "Utility",
      "desktop": "Skrivebord",
      "online": "Online",
      "view_all_product": "Se alle produkter",
      "product_info_27": "Rip dine favoritt Blu-ray/DVD-filmer eller -videoer til populære formater",
      "product_info_29": "Kraftig programvare for å spille av Blu-ray/DVD-videoer og lyd",
      "product_info_31": "Lag Blu-ray-plate/mappe/ISO-fil med din egen video",
      "product_info_32": "Sikkerhetskopier/kopier favoritt Blu-ray til disk/mappe/iso-filer",
      "product_info_28": "Rip dine favoritt Blu-ray/DVD-filmer eller -videoer til populære formater på Mac",
      "product_info_30": "Kraftig programvare for å spille av Blu-ray/DVD-videoer og lyd på Mac",
      "product_info_21": "Rip DVD til et hvilket som helst populært videoformat raskt av full kvalitet",
      "product_info_23": "Lag DVD fra videoer og brenn video til DVD/Blu-ray fritt",
      "product_info_25": "Kopier DVD til DVD-plate/mappe/ISO-filer i forholdet 1:1",
      "product_info_22": "Ripp DVD til et hvilket som helst populært videoformat raskt av full kvalitet på Mac",
      "product_info_24": "Lag DVD fra videoer og brenn video til DVD/Blu-ray fritt på Mac",
      "product_info_26": "Kopier DVD til DVD-plate/mappe/ISO-filer i forholdet 1:1 på Mac",
      "product_info_1": "Ripp DVD, konverter 4K-video, rediger og oppskaler videoer til 5K/8K",
      "product_info_19": "Reparer ødelagte videoer med høy nøyaktighet og støtter mange formater",
      "product_info_5": "Konverter hvilken som helst video til MP3, MP4, MOV, WAV og andre 350-formater",
      "product_info_9": "Oppskaler oppløsning, optimer lysstyrken og fjern videostøy",
      "product_info_11": "Det enkleste verktøyet for å fange skjerm, spill, lyd osv. med høy kvalitet",
      "product_info_13": "Konverter hvilken som helst 2D-video til 3D-video og konverter 3D til 2D-video",
      "product_info_7": "Konverter 4K-video til 4K/1080P og vanlige videoer",
      "product_info_15": "Konverter TS-video til forskjellige populære video-/lydformater",
      "product_info_2": "Ripp DVD, konverter 4K-video, rediger og oppskaler videoer til 5K/8K på Mac",
      "product_info_20": "Reparer ødelagte videoer med høy nøyaktighet og støtter mange formater på Mac",
      "product_info_6": "Konverter hvilken som helst video til MP3, MP4, MOV, WAV og andre 350-formater på Mac",
      "product_info_10": "Oppskaler oppløsning, optimer lysstyrken og fjern videostøy på Mac",
      "product_info_12": "Det enkleste verktøyet for å fange skjerm, spill, lyd osv. med høy kvalitet på Mac",
      "product_info_14": "Konverter hvilken som helst 2D-video til 3D-video og konverter 3D til 2D-video på Mac",
      "product_info_48": "Konverter 4K-video til 4K/1080P og vanlige videoer på Mac",
      "product_info_16": "Konverter TS-video til forskjellige populære video-/lydformater på Mac",
      "product_info_46": "Rip og konverter DVDer til MP3 og støtter andre lydformater",
      "product_info_38": "Tilbakestill passordet for Windows Admin og Standard brukerkonto på sekunder",
      "product_info_35": "Konverter alle PDF-filer nøyaktig til Word med OCR",
      "product_info_34": "Konverter PDF til Word, Excel, HTML og bilde med OCR",
      "product_info_44": "Fjern enkelt vannmerker fra mange bildefilformater gratis online",
  }
}
  for(var i18n_key in i18n_private){
    if(!i18n[i18n_key]){
      i18n[i18n_key]={}
    }
    for(var i18n_private_key in i18n_private[i18n_key]){
      i18n[i18n_key][i18n_private_key]=i18n_private[i18n_key][i18n_private_key]
    }
  }